// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:36:10.119Z
// Property: Tammaron Village Apartments (ID: 6767906449165631)
// Collections: 18 amenities, 4 floorplans (live), 31 photos, 85 POIs, 1 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165631",
  "property_external_id": "qr2y1dw",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/tammaron-village-apartments-oklahoma-city-ok/qr2y1dw/",
  "property_google_business_url": "https://www.google.com/maps/place/Tammaron+Village+Apartments/data=!4m2!3m1!1s0x0:0xf02bf93cbed7ca6b?sa=X&ved=2ahUKEwjCvvamgL2SAxXISjABHZ-aCr8Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "tammaron-village-apartments",
  "property_name": "Tammaron Village Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/tammaron-village/",
  "property_domain": null,
  "property_address": "11100 Roxboro",
  "property_full_address": "11100 Roxboro, Oklahoma City, OK, 73162",
  "property_address_1": "11100 Roxboro",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73162",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Roxboro",
  "property_address_latitude": "35.581",
  "property_address_longitude": "-97.65",
  "property_email": "tammaronvillage@caseusa.com",
  "property_phone": "(405) 358-2175",
  "property_call_tracking_phone": "844-685-0723",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Tammaron Village Apartments in vibrant Oklahoma City, where contemporary living meets comfort. Choose from stylish studio, one, or two-bedroom floor plans. Enjoy resort-style amenities, including two sparkling pools, an upscale clubhouse, and a dog park. Embrace effortless living with flexible payment options and 24-hour maintenance. Secure your new home today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Tammaron Village Apartments, your haven in the heart of Oklahoma City, Oklahoma. Our community offers a diverse range of stylish floor plans—including cozy studios, spacious one-bedroom, and inviting two-bedroom apartments—each designed to meet your unique lifestyle needs. Experience the perfect blend of comfort and convenience in a home that truly feels like your own.\n\nAt Tammaron Village, we pride ourselves on an exceptional selection of amenities aimed at enhancing your living experience. Enjoy two shimmering swimming pools with sundecks perfect for soaking up the sun, or entertain friends and family in our upscale clubhouse. Your peace of mind is our priority, with limited access gates ensuring security, as well as 24-hour emergency maintenance for any urgent needs that may arise.\n\nOur community is pet-friendly, featuring an onsite dog park where your furry friends can play and socialize. Each apartment comes equipped with modern conveniences, such as a stackable washer & dryer, spacious closets, and a fully-equipped kitchen complete with a microwave and dishwasher. Additionally, our preinstalled WiFi modem powered by Cox ensures you’re connected, while electronic payment options and flexible payment plans make managing your finances easy.\n\nDiscover the lifestyle you’ve been searching for at Tammaron Village Apartments. Whether you're looking to unwind by the pool, catch up on work in our business center, or simply relax in a well-appointed space, we have it all. Find your new home today—browse our availability or schedule a tour to experience our vibrant community firsthand!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-c386-7105-9e5c-0d9179a998af.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of an apartment building with a swimming pool and courtyard.",
    "public_id": "019cfb49-c386-7105-9e5c-0d9179a998af",
    "storage_key": "property/6767906449165631/019cfb49-c386-7105-9e5c-0d9179a998af.webp",
    "width": 1350,
    "height": 900
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "400",
  "property_year_built": "1983",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed Restrictions",
  "property_pet_policy_description": "Above applies to All Pets",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://tammaronvillageapartmentsoklahomacity.securecafe.com/onlineleasing/tammaron-village-apartments/floorplans.aspx",
  "property_resident_portal_url": "https://tammaronvillageapartmentsoklahomacity.securecafe.com/residentservices/tammaron-village-apartments/userlogin.aspx",
  "property_apply_now_url": "https://tammaronvillageapartmentsoklahomacity.securecafe.com/onlineleasing/tammaron-village-apartments/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-b3a1-738a-8726-59e90ac5578a.webp",
  "property_primary_logo_media": {
    "alt_text": "Tamarron Village logo",
    "public_id": "019cfb48-b3a1-738a-8726-59e90ac5578a",
    "storage_key": "property/6767906449165631/019cfb48-b3a1-738a-8726-59e90ac5578a.webp",
    "width": 2560,
    "height": 699
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-b991-72db-8618-e3be8babf713.webp",
  "property_secondary_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb49-b991-72db-8618-e3be8babf713",
    "storage_key": "property/6767906449165631/019cfb49-b991-72db-8618-e3be8babf713.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-d82d-7220-8d99-32b51f7a54a2.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Tamaron Village logo",
    "public_id": "019cfb49-d82d-7220-8d99-32b51f7a54a2",
    "storage_key": "property/6767906449165631/019cfb49-d82d-7220-8d99-32b51f7a54a2.webp",
    "width": 640,
    "height": 175
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-e08b-73b5-b93f-8d82ed14a7d6.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Tamarron Village logo",
    "public_id": "019cfb49-e08b-73b5-b93f-8d82ed14a7d6",
    "storage_key": "property/6767906449165631/019cfb49-e08b-73b5-b93f-8d82ed14a7d6.webp",
    "width": 640,
    "height": 175
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#434442",
  "property_secondary_color": "#617a7e",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#ffb548",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "500 - 850",
  "property_sqft_min": "500",
  "property_sqft_max": "850",
  "property_price_range": "699 - 1009",
  "property_price_min": "699",
  "property_price_max": "1009",
  "property_available_units": 13,
  "property_facebook_url": "https://www.facebook.com/Tammaronvillageapts/photos/",
  "property_instagram_url": "https://www.instagram.com/tammaronvillageapartmentsokc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ9Y70foEEsocRa8rXvjz5K_A",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/tammaron-village-oklahoma-city-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Tammaron Village Apartments",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection in Your New Home",
  "property_home_amenities_blurb": "Welcome to Tammaron Village Apartments in vibrant Oklahoma City, where comfort meets convenience. Choose from stylish studio, one, or two-bedroom layouts, and indulge in top-tier amenities like two pools, an upscale clubhouse, and an onsite dog park. Elevate your living experience today—your perfect apartment awaits!",
  "property_home_floorplans_blurb": "Welcome to Tammaron Village Apartments in vibrant Oklahoma City! Choose from our thoughtfully designed studio, one-bedroom, and two-bedroom floor plans that cater to your unique lifestyle. Your ideal home awaits—browse our available apartments today and elevate your living experience in this welcoming community.",
  "property_home_gallery_blurb": "Welcome to Tammaron Village Apartments in the heart of Oklahoma City, where comfort meets style. Choose from spacious studio to two-bedroom layouts, all featuring modern amenities like a fully equipped kitchen, upscale clubhouse, and two refreshing swimming pools. Picture yourself living here, where your ideal lifestyle awaits!",
  "property_home_neighborhood_blurb": "Tammaron Village Apartments offers a vibrant Oklahoma City lifestyle, surrounded by enriching destinations. From the tranquility of Martin Park Nature Center to the thrill of Blue Zoo Aquarium, every day holds a new adventure. Unwind at local libraries, stay active at nearby fitness centers, or explore unique attractions just moments away. ",
  "property_home_reviews_blurb": "At Tammaron Village Apartments in Oklahoma City, residents describe their home as a \"spiritual sanctuary\" where a \"kind, helpful\" staff ensures every need is met. Experience a supportive atmosphere and fantastic amenities that create an ideal environment for thriving. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Embrace vibrant living at Tammaron Village Apartments, surrounded by a wealth of local treasures. Enjoy nature at Martin Park or explore the fascinating Oklahoma Museum of Flying. With easy access to Quail Springs Mall and top-notch fitness centers, your ideal lifestyle is just outside your door. See what’s nearby!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Tammaron Village Apartments in Oklahoma City, vibrant living awaits. Choose from thoughtfully designed studio, one, or two-bedroom floor plans, all featuring spacious kitchens and modern conveniences. Enjoy resort-style amenities, including two refreshing pools, a stylish clubhouse, and a dog park, all tailored for your comfort and lifestyle.",
  "property_applynow_blurb": "At Tammaron Village Apartments in Oklahoma City, comfort meets convenience. Choose from stylish studio, one-bedroom, and two-bedroom layouts, equipped with modern amenities like a fully stocked kitchen, spacious closets, and an onsite dog park. With two refreshing pools and a clubhouse, your oasis awaits—lease online today and secure your new home!",
  "property_contactus_blurb": "At Tammaron Village Apartments in vibrant Oklahoma City, we offer a variety of thoughtfully designed floor plans, including cozy studios, spacious one-bedrooms, and inviting two-bedrooms. Each home is crafted for comfort and style. Have questions? Reach out to our leasing team today and let us help you find your perfect fit!",
  "property_faqs_blurb": "At Tammaron Village Apartments in Oklahoma City, our diverse floor plans—ranging from cozy studios to spacious two-bedroom layouts—cater to every lifestyle. Whether you’re seeking comfort or space, we’ve got you covered. Have questions? Dive into our FAQs page for valuable insights about our vibrant community. Your perfect home awaits!",
  "property_floorplans_blurb": "At Tammaron Village Apartments in Oklahoma City, a variety of thoughtfully designed floor plans await, from cozy studios to spacious two-bedrooms. Each layout maximizes comfort and style, making it easy to find your ideal living space. Browse our available apartment homes today to see what suits you best!",
  "property_gallery_blurb": "At Tammaron Village Apartments in Oklahoma City, picture yourself unwinding in a spacious studio or enjoying the comforts of a one or two-bedroom home. With two shimmering pools, a chic clubhouse, and an onsite dog park, your perfect lifestyle awaits. Dive into the gallery and envision your new sanctuary!",
  "property_interactivemap_blurb": "At Tammaron Village Apartments in Oklahoma City, choose from stylish studio, one, and two-bedroom layouts designed for your lifestyle. Enjoy upscale amenities like two sparkling pools, an inviting clubhouse, and a dog park, all with the convenience of flexible payment options. Your perfect home awaits—check out our interactive community map today!",
  "property_pets_blurb": "Nestled in the heart of Oklahoma City, Tammaron Village Apartments offers a serene escape infused with modern amenities. With spacious layouts and a friendly atmosphere, it's the perfect haven for you and your furry companions, ensuring every day feels like home sweet home. Embrace a lifestyle of comfort and convenience today!",
  "property_referafriend_blurb": "At Tammaron Village Apartments in Oklahoma City, we celebrate community connections! With inviting studio, one-bedroom, and two-bedroom floor plans, your ideal living space awaits. Share the joy of vibrant living and refer a friend today—great friends make great neighbors! Embrace a lifestyle where both comfort and camaraderie thrive.",
  "property_residentaccess_blurb": "At Tammaron Village Apartments in Oklahoma City, our diverse floor plans cater to every lifestyle, from cozy studios to spacious two-bedroom layouts. Current residents can easily access their portal to pay rent, schedule maintenance, and enjoy seamless community living. Join us in experiencing elevated comfort at Tammaron Village!",
  "property_reviews_blurb": "At Tammaron Village Apartments in Oklahoma City, our residents describe their experience as a \"spiritual sanctuary,\" highlighting our \"kind staff\" and \"impeccable grounds.\" With swift maintenance and a supportive team, here, you’ll find not just a home, but a thriving community. Hear from our satisfied residents today!",
  "property_created_at": "1753982393404",
  "property_scheduletour_blurb": "Nestled in the heart of Oklahoma City, Tammaron Village Apartments offers an array of thoughtfully designed floor plans, including cozy studios and spacious two-bedroom options. Experience vibrant living spaces that cater to your lifestyle. Curious about our community? Schedule a tour today and hear firsthand from our satisfied residents!",
  "property_thankyou_blurb": "Thank you for reaching out to Tammaron Village Apartments in vibrant Oklahoma City! From cozy studios to spacious two-bedroom layouts, we have the perfect home to fit your lifestyle. Our team will connect soon to assist you in finding your ideal apartment haven. Stay tuned for exciting updates!",
  "property_virtualtours_blurb": "Step into comfort at Tammaron Village Apartments in Oklahoma City, where each thoughtfully designed layout—studio, one, and two-bedroom—creates the perfect haven for your lifestyle. Experience modern living at its finest; take a virtual tour today and envision your new home!",
  "property_copyright": "2025 All Rights Reserved. Tammaron Village Apartments",
  "property_seo_title_home": "Tammaron Village Apartments |  Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_home": "Experience modern living at Tammaron Village Apartments in OKC! Choose from studios to two-bedrooms with luxury amenities, pools, and an onsite dog park.",
  "property_seo_title_floorplans": "Floor Plans | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Tammaron Village Apartments in Oklahoma City! From studios to spacious two-bedroom layouts, your perfect home awaits. Browse now!",
  "property_seo_title_amenities": "Amenities | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Live vibrantly at Tammaron Village Apartments, OKC! Enjoy upscale amenities, two pools, and spacious floor plans tailored for you.",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_gallery": "Experience your ideal lifestyle at Tammaron Village Apartments in OKC with spacious layouts, relaxing pools, a dog park, and upscale amenities.",
  "property_seo_title_virtualtours": "Virtual Tours | Tammaron Village Apartments Apartments",
  "property_seo_description_virtualtours": "Step inside Tammaron Village Apartments in Oklahoma City! Take a virtual tour to explore our stylish studio, one, and two-bedroom homes. Your new life awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Tammaron Village Apartments Apartments",
  "property_seo_description_interactivemap": "Discover Tammaron Village Apartments in OKC! Stylish layouts and resort-style amenities await your ideal home. Map your future today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the charm of Tammaron Village Apartments in Oklahoma City! Experience vibrant neighborhoods, local favorites, and nearby hotspots just steps from home.",
  "property_seo_title_contact": "Contact Us | Tammaron Village Apartments",
  "property_seo_description_contact": "Explore Tammaron Village Apartments in OKC! Discover your ideal studio or 1-2 bedroom home. Contact our leasing team with any questions!",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_faqs": "Get answers to your burning questions at Tammaron Village Apartments! Discover amenities, floor plans, and life in Oklahoma City’s vibrant community.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_reviews": "Join the vibrant community at Tammaron Village Apartments in OKC! Check out residents' reviews and see why they love our amenities and cozy floor plans!",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_applynow": "Experience luxury living at Tammaron Village in Oklahoma City! Choose from spacious studios to two-bedroom apartments with top-notch amenities. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Tammaron Village Apartments",
  "property_seo_description_residentaccess": "Log in to Tammaron Village Apartments' resident portal for seamless rent payments, hassle-free maintenance requests, and a community living experience in OKC!",
  "property_seo_title_referafriend": "Refer A Friend | Tammaron Village Apartments",
  "property_seo_description_referafriend": "Refer a friend to Tammaron Village Apartments in Oklahoma City! Great friends make great neighbors—share the experience of vibrant community living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Tammaron Village Apartments",
  "property_seo_description_scheduletour": "Experience life at Tammaron Village in Oklahoma City! Schedule your tour today and see why our vibrant community is the perfect place to call home.",
  "property_seo_title_privacy": "Privacy Policy | Tammaron Village Apartments",
  "property_seo_description_privacy": "Safeguarding your comfort at Tammaron Village Apartments. Dive into our privacy policy and learn how we protect your personal information in Oklahoma City.",
  "property_seo_title_accessibility": "Website Accessibility | Tammaron Village Apartments",
  "property_seo_description_accessibility": "Enjoy seamless living at Tammaron Village Apartments, OKC, where our focus on digital inclusion makes accessing community resources effortless.",
  "property_seo_title_sitemap": "Sitemap | Tammaron Village Apartments",
  "property_seo_description_sitemap": "Navigate Tammaron Village Apartments in Oklahoma City with ease! Check out our sitemap for a seamless journey to your future home and community details.",
  "property_seo_title_thankyou": "Thank You | Tammaron Village Apartments",
  "property_seo_description_thankyou": "Thank you for your interest in Tammaron Village Apartments! A team member will be in touch soon to help you find your perfect Oklahoma City home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865874068",
  "amenities": [
    {
      "id": "ec_9b40a14eb7d2c1659487629b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127397207",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_515c5b476213478a98b9caac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127397208",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e887eb5fffcd27ba0d7d5d2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127397209",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d1d949ef73a43714dcb67ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127397210",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7ab78a325c54105d18aea86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127397211",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be81e2949359f5f1a9db082a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127397212",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_365d2817e320ac7311e369b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "128042557",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5f4318859bbbeb28f77f6c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "128017292",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ace33413810518a1cd94d7f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127397213",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a7d53c0a35e8554bcf4a24a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127398664",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d24d1bd60e05a169fe11c29e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127398665",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_900527e777f47498c197c874",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127398666",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e0430742391b9f5cc1f7c46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127398667",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f76552e99856a8cff1d71195",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127398668",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25f03a8f7b8f45febf4f92a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127398669",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc153456816b6d85e97a0343",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127398670",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4345b520bb7657e92dd641e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127398671",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7d9283a157781d4f3473e6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "yardi",
      "external_id": "127398672",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_d607890d-3569-4ac3-b1a7-3d2b3460c178",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d20b0-245f-73a4-8517-3172bc67f997.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with landscaping and a curved walkway.",
        "public_id": "019d20b0-245f-73a4-8517-3172bc67f997",
        "storage_key": "property/6767906449165631/019d20b0-245f-73a4-8517-3172bc67f997.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Exterior view of a suburban apartment community with brick buildings, green lawns, and a curved sidewalk.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment building with landscaping and a curved walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/gh1io46fpBQxPjEkreD8_YiGeEbNjHqvjm90HmT5yms/116/image.jpg"
    },
    {
      "id": "custom_7318bd6f-236f-473f-90c0-5141f5741bc3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-5ce3-72f4-a17e-5b46599aacd6.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-building apartment community with parked cars and landscaped grounds.",
        "public_id": "019cfb49-5ce3-72f4-a17e-5b46599aacd6",
        "storage_key": "property/6767906449165631/019cfb49-5ce3-72f4-a17e-5b46599aacd6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Exterior view of a well-maintained apartment complex with parking and green spaces.",
      "link": "",
      "alt_text": "Exterior view of a multi-building apartment community with parked cars and landscaped grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/oBCmzr3mxv3dHZd3cLPxWf9Lapc_5R8s7X-XGrwHpR4/116/image.jpg"
    },
    {
      "id": "custom_741ceda7-77b7-4774-8b87-59a5219c4ca6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-6100-77e8-af57-598d50d2d21c.webp",
      "image_media": {
        "alt_text": "Exterior of a single-story leasing office with a metal roof, parking lot, and trees.",
        "public_id": "019cfb49-6100-77e8-af57-598d50d2d21c",
        "storage_key": "property/6767906449165631/019cfb49-6100-77e8-af57-598d50d2d21c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Exterior view of the community leasing office with parking, landscaping, and mature trees.",
      "link": "",
      "alt_text": "Exterior of a single-story leasing office with a metal roof, parking lot, and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/epBpzAS0HLQqjj6WgRf8zlA21Snjyp0o1P2P877GWG4/116/image.jpg"
    },
    {
      "id": "custom_7bbb1347-d507-44b1-8a1d-7e853b2dc972",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-b51a-71eb-83d5-50f78f4e2ae8.webp",
      "image_media": {
        "alt_text": "Exterior view of the leasing office at Tammaron Village with signage and landscaping.",
        "public_id": "019cfb48-b51a-71eb-83d5-50f78f4e2ae8",
        "storage_key": "property/6767906449165631/019cfb48-b51a-71eb-83d5-50f78f4e2ae8.webp",
        "width": 1000,
        "height": 800
      },
      "title": "Community",
      "description": "Exterior photo of the Tammaron Village leasing office, showing signage, entrance columns, and surrounding landscaping.",
      "link": "",
      "alt_text": "Exterior view of the leasing office at Tammaron Village with signage and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165631%2F3b03b335b9b5cf03c4abdb8090618cc8.webp"
    },
    {
      "id": "custom_091108c4-141c-4453-a688-8c0995a1db6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-be8e-75ea-8b56-07c0a5bcac29.webp",
      "image_media": {
        "alt_text": "Outdoor community playground with red horse-jump structures and a red tunnel on a grassy field.",
        "public_id": "019cfb48-be8e-75ea-8b56-07c0a5bcac29",
        "storage_key": "property/6767906449165631/019cfb48-be8e-75ea-8b56-07c0a5bcac29.webp",
        "width": 998,
        "height": 598
      },
      "title": "Community",
      "description": "Outdoor community playground at the property with colorful play equipment and a tunnel.",
      "link": "",
      "alt_text": "Outdoor community playground with red horse-jump structures and a red tunnel on a grassy field.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165631%2Fcd524ee21e350bda8840d45c7b02c71a.webp"
    },
    {
      "id": "custom_bcf0e665-8d6f-4898-b92f-d2b1bb38d7a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d20b0-27f8-7583-8516-e0eed6f6903b.webp",
      "image_media": {
        "alt_text": "Aerial view of a community pool with lounge chairs and adjacent buildings.",
        "public_id": "019d20b0-27f8-7583-8516-e0eed6f6903b",
        "storage_key": "property/6767906449165631/019d20b0-27f8-7583-8516-e0eed6f6903b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Aerial view of a residential community pool area with seating and clubhouse in a multifamily complex.",
      "link": "",
      "alt_text": "Aerial view of a community pool with lounge chairs and adjacent buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/0Z3sUSlCx7-rGYuwhHo6Zo9cULq6XZZMr6dJJXVfa0g/116/image.jpg"
    },
    {
      "id": "custom_9cdb1597-ddea-486e-8646-64535fdc2e9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-6514-7753-af84-e12efffb19bf.webp",
      "image_media": {
        "alt_text": "Aerial view of a large rectangular outdoor pool surrounded by lounge chairs on a concrete deck.",
        "public_id": "019cfb49-6514-7753-af84-e12efffb19bf",
        "storage_key": "property/6767906449165631/019cfb49-6514-7753-af84-e12efffb19bf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Aerial view of the community pool area with loungers and surrounding amenities.",
      "link": "",
      "alt_text": "Aerial view of a large rectangular outdoor pool surrounded by lounge chairs on a concrete deck.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/X-qVd5dsfp8-8N66uNfs0RDHONkBbMT6wiIhAiyXiO0/116/image.jpg"
    },
    {
      "id": "custom_214d0c46-4d6e-4fb5-a9f0-6a45ce1ba383",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d20b0-25f1-7414-aff9-b79a228c24a4.webp",
      "image_media": {
        "alt_text": "Outdoor pool area of an apartment community with lounge chairs and fencing.",
        "public_id": "019d20b0-25f1-7414-aff9-b79a228c24a4",
        "storage_key": "property/6767906449165631/019d20b0-25f1-7414-aff9-b79a228c24a4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Outdoor pool at a multifamily community with lounge chairs and landscaped surroundings.",
      "link": "",
      "alt_text": "Outdoor pool area of an apartment community with lounge chairs and fencing.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/i4LsJ4prDkEiyy8PCuyfxo7h-O_O_nDTc25XD-VXxQU/116/image.jpg"
    },
    {
      "id": "custom_7796fc68-82e8-4567-820b-02ea4e4f193e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-6957-749d-9544-5fea41752562.webp",
      "image_media": {
        "alt_text": "Outdoor communal deck with a dark wooden pergola, seating area, and white brick walls.",
        "public_id": "019cfb49-6957-749d-9544-5fea41752562",
        "storage_key": "property/6767906449165631/019cfb49-6957-749d-9544-5fea41752562.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Shared outdoor patio with a dark wooden pergola, brick walls, and seating at a modern apartment community.",
      "link": "",
      "alt_text": "Outdoor communal deck with a dark wooden pergola, seating area, and white brick walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/vtZMeXjCvbnIqMsp09qfeiwo44f1-zKV_4jvQIUNYo4/116/image.jpg"
    },
    {
      "id": "custom_1895bda6-99b1-4c75-ba9a-c9a0d549282a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-b3a2-75d1-8c1c-2f8f4a05e478.webp",
      "image_media": {
        "alt_text": "Bright community lounge with high ceilings, chandeliers, large windows, seating and a kitchenette.",
        "public_id": "019cfb48-b3a2-75d1-8c1c-2f8f4a05e478",
        "storage_key": "property/6767906449165631/019cfb48-b3a2-75d1-8c1c-2f8f4a05e478.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Spacious resident lounge with modern furnishings, a coffee bar, and workstations for convenient, social living.",
      "link": "",
      "alt_text": "Bright community lounge with high ceilings, chandeliers, large windows, seating and a kitchenette.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165631%2Fb39b7fcc62c8233d64ef0bd9dea8e354.webp"
    },
    {
      "id": "custom_2e24823f-c450-4337-b22c-6e74fe1eb3cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-b39a-718b-88fb-f179b35f3995.webp",
      "image_media": {
        "alt_text": "Laundry room with stacked washers and dryers along the walls and a central metal table.",
        "public_id": "019cfb48-b39a-718b-88fb-f179b35f3995",
        "storage_key": "property/6767906449165631/019cfb48-b39a-718b-88fb-f179b35f3995.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "On-site communal laundry facility in a modern apartment community with multiple washers and dryers and a central work table.",
      "link": "",
      "alt_text": "Laundry room with stacked washers and dryers along the walls and a central metal table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165631%2F2f2766fd711153c159fe26d98da5e667.webp"
    },
    {
      "id": "custom_abca0f83-38bd-4e17-9df2-a8b2d74ec4ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-b3a1-738a-8726-60929f66f40d.webp",
      "image_media": {
        "alt_text": "Living room with a beige sofa, wooden coffee table, and a large window with sheer white curtains.",
        "public_id": "019cfb48-b3a1-738a-8726-60929f66f40d",
        "storage_key": "property/6767906449165631/019cfb48-b3a1-738a-8726-60929f66f40d.webp",
        "width": 1560,
        "height": 1040
      },
      "title": "Apartment",
      "description": "Bright living room in a modern apartment with a neutral palette, decorative pillows, and natural light from a large window.",
      "link": "",
      "alt_text": "Living room with a beige sofa, wooden coffee table, and a large window with sheer white curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165631%2F0dc7b568f068480fef9a8032a3a0f4e2.webp"
    },
    {
      "id": "custom_aa6d2a5d-bf91-4adb-90e6-89676b6f61b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-b3a1-738a-8726-5e1833f96032.webp",
      "image_media": {
        "alt_text": "Dining area with a round glass table, two beige upholstered chairs, pendant light, gray accent wall.",
        "public_id": "019cfb48-b3a1-738a-8726-5e1833f96032",
        "storage_key": "property/6767906449165631/019cfb48-b3a1-738a-8726-5e1833f96032.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Cozy dining nook in a modern apartment featuring a round glass table, two beige upholstered chairs, and a pendant light.",
      "link": "",
      "alt_text": "Dining area with a round glass table, two beige upholstered chairs, pendant light, gray accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165631%2Fc529b7036b912db8b07f1c9dc54be9bd.webp"
    },
    {
      "id": "custom_08d91f5a-0691-455c-b832-72d2e70f4aef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-b3a2-75d1-8c1c-3286c058f238.webp",
      "image_media": {
        "alt_text": "Bright bedroom with a queen bed, two nightstands, lamps, and a window with blinds.",
        "public_id": "019cfb48-b3a2-75d1-8c1c-3286c058f238",
        "storage_key": "property/6767906449165631/019cfb48-b3a2-75d1-8c1c-3286c058f238.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Spacious apartment bedroom with neutral decor, a large bed, matching lamps, and a sunburst mirror above the dresser.",
      "link": "",
      "alt_text": "Bright bedroom with a queen bed, two nightstands, lamps, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165631%2F8492e6304e6fa3355df94393c8ae175d.webp"
    },
    {
      "id": "custom_bb62e569-7c45-44e0-af6a-a6527c66609c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-b3a2-75d1-8c1c-39d26e6b60f8.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a beige sofa, tufted brown ottoman, and a window with chevron-pattern curtains.",
        "public_id": "019cfb48-b3a2-75d1-8c1c-39d26e6b60f8",
        "storage_key": "property/6767906449165631/019cfb48-b3a2-75d1-8c1c-39d26e6b60f8.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Bright living room in a modern apartment with a neutral palette, decorative pillows, and a large window.",
      "link": "",
      "alt_text": "Living room in an apartment with a beige sofa, tufted brown ottoman, and a window with chevron-pattern curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165631%2F57b1f4fe73579e4443b0b8fadd5b5298.webp"
    },
    {
      "id": "custom_387035b7-3d4b-42c7-b53a-7fa4c0d7a81f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-b3a2-75d1-8c1c-350b94808d5c.webp",
      "image_media": {
        "alt_text": "Kitchen area with double stainless sink, light wood cabinets, and decorative items on the counter.",
        "public_id": "019cfb48-b3a2-75d1-8c1c-350b94808d5c",
        "storage_key": "property/6767906449165631/019cfb48-b3a2-75d1-8c1c-350b94808d5c.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Cozy apartment kitchen featuring a double basin sink, light oak cabinetry, and farmhouse-style decor.",
      "link": "",
      "alt_text": "Kitchen area with double stainless sink, light wood cabinets, and decorative items on the counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165631%2Fb835e1a1414d4d55b86733c47179421a.webp"
    },
    {
      "id": "custom_ada5aabc-f179-4e67-9d5b-846e3fd0d5ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d20af-e54d-7367-86f5-fd7807e64aa6.webp",
      "image_media": {
        "alt_text": "Living room in a modern apartment with white and black seating, wood floors, and large windows.",
        "public_id": "019d20af-e54d-7367-86f5-fd7807e64aa6",
        "storage_key": "property/6767906449165631/019d20af-e54d-7367-86f5-fd7807e64aa6.webp",
        "width": 1576,
        "height": 1630
      },
      "title": "Apartment",
      "description": "Bright, contemporary living room in a stylish apartment with natural light and sleek furnishings.",
      "link": "",
      "alt_text": "Living room in a modern apartment with white and black seating, wood floors, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165631%2F9b63c97e651b6c7b35a7ce0148a1512a.webp"
    },
    {
      "id": "custom_a0a0212b-9515-46c5-998e-286b853db037",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-ce52-71f7-9697-cdccb3846c26.webp",
      "image_media": {
        "alt_text": "Living room scene with gray sofa, decorative pillows, a floor lamp, and framed wall art.",
        "public_id": "019cfb48-ce52-71f7-9697-cdccb3846c26",
        "storage_key": "property/6767906449165631/019cfb48-ce52-71f7-9697-cdccb3846c26.webp",
        "width": 2000,
        "height": 500
      },
      "title": "Apartment",
      "description": "Cozy apartment living room featuring a gray sofa, patterned throw pillows, a floor lamp, and framed artwork.",
      "link": "",
      "alt_text": "Living room scene with gray sofa, decorative pillows, a floor lamp, and framed wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165631%2F2e712bdc7f8e60f6d9d91c924a6cbe0e.webp"
    },
    {
      "id": "custom_cd13c3fb-0103-4567-a505-888f7040115f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d20b0-323a-7130-a97d-6cba0671f4ef.webp",
      "image_media": {
        "alt_text": "Compact apartment kitchen with double sink, fridge, stove, and wood cabinets.",
        "public_id": "019d20b0-323a-7130-a97d-6cba0671f4ef",
        "storage_key": "property/6767906449165631/019d20b0-323a-7130-a97d-6cba0671f4ef.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy apartment kitchen featuring white appliances, a double sink, and warm wood cabinetry along a brown countertop.",
      "link": "",
      "alt_text": "Compact apartment kitchen with double sink, fridge, stove, and wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/GRLYixTenZvrlFFJJar1r5m2iW1muIJWMCkaD8CKRtY/116/image.jpg"
    },
    {
      "id": "custom_a82765e5-af58-4b23-97a3-7654ad41f46c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d20b0-3368-76e4-80bf-5ef6fa54d2d6.webp",
      "image_media": {
        "alt_text": "Bathroom with sink, mirror, beige countertop, toilet, and towel rack.",
        "public_id": "019d20b0-3368-76e4-80bf-5ef6fa54d2d6",
        "storage_key": "property/6767906449165631/019d20b0-3368-76e4-80bf-5ef6fa54d2d6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with a wooden vanity, beige countertop, mirror, and towels.",
      "link": "",
      "alt_text": "Bathroom with sink, mirror, beige countertop, toilet, and towel rack.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/AodMxFDwa_55nHtrcSY4ZBvNcL1f9uTUl9mYBOIENi8/116/image.jpg"
    },
    {
      "id": "custom_656f9afe-dfd4-4c15-8423-880950b91a18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d20b0-336f-706c-b8c3-934f849491c6.webp",
      "image_media": {
        "alt_text": "Open kitchen pass-through to dining area in a neutral apartment interior with wood cabinets.",
        "public_id": "019d20b0-336f-706c-b8c3-934f849491c6",
        "storage_key": "property/6767906449165631/019d20b0-336f-706c-b8c3-934f849491c6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy apartment interior featuring a kitchen pass-through, dining table, and living space in warm neutrals.",
      "link": "",
      "alt_text": "Open kitchen pass-through to dining area in a neutral apartment interior with wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Bowrp-gMVCO9o9dZ6CMnM3R2jMnFZwiaSs1MIGQYfUk/116/image.jpg"
    },
    {
      "id": "custom_8af7c34c-d125-442a-a5e4-884c3d149de0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d20b0-3380-7712-8efd-da056a2e5c97.webp",
      "image_media": {
        "alt_text": "Bedroom in apartment with wooden bed, bedside lamp, and open closet.",
        "public_id": "019d20b0-3380-7712-8efd-da056a2e5c97",
        "storage_key": "property/6767906449165631/019d20b0-3380-7712-8efd-da056a2e5c97.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with a wooden bed, decorative pillows, and an open closet.",
      "link": "",
      "alt_text": "Bedroom in apartment with wooden bed, bedside lamp, and open closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ryJSvbeQ7DfIFKBzj3GYief4iAui7YE2LJ8K4fynOQs/116/image.jpg"
    },
    {
      "id": "custom_6069f520-6e7e-462b-bd4d-534d367f8f09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d20b0-3e6c-75ca-9929-fbde785d6c58.webp",
      "image_media": {
        "alt_text": "Compact apartment kitchen with sink, stove, fridge, microwave, and wooden cabinets.",
        "public_id": "019d20b0-3e6c-75ca-9929-fbde785d6c58",
        "storage_key": "property/6767906449165631/019d20b0-3e6c-75ca-9929-fbde785d6c58.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy apartment kitchen with beige counters, wooden cabinets, a microwave, stove, and refrigerator.",
      "link": "",
      "alt_text": "Compact apartment kitchen with sink, stove, fridge, microwave, and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/sb2DzrEiQOliuHFJy8q8EQP2s8tKF0NugGF1azd7lYM/116/image.jpg"
    },
    {
      "id": "custom_a9abd486-38cb-41b1-9a58-fd7052da51d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d20b0-4165-72fb-aaa3-0cd1b34bf5db.webp",
      "image_media": {
        "alt_text": "Bathroom showing a vanity, wall cabinet, toilet, and a shower-tub with a floral curtain.",
        "public_id": "019d20b0-4165-72fb-aaa3-0cd1b34bf5db",
        "storage_key": "property/6767906449165631/019d20b0-4165-72fb-aaa3-0cd1b34bf5db.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy apartment bathroom with vanity, storage cabinet, toilet, and a shower-tub with a floral curtain.",
      "link": "",
      "alt_text": "Bathroom showing a vanity, wall cabinet, toilet, and a shower-tub with a floral curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/eSlZ3Ps5G56QVNwtOoa6dvPHAHyA5UjZNKbALOQhs_g/116/image.jpg"
    },
    {
      "id": "custom_6728680d-b04a-442c-b72b-5ad456f80b0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d20b0-4279-779b-aa48-7aee98b8e207.webp",
      "image_media": {
        "alt_text": "Corner dining nook with round wooden table and four stools in an apartment.",
        "public_id": "019d20b0-4279-779b-aa48-7aee98b8e207",
        "storage_key": "property/6767906449165631/019d20b0-4279-779b-aa48-7aee98b8e207.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Cozy apartment dining area with a round table, four stools, a wall clock and coffee-themed wall art.",
      "link": "",
      "alt_text": "Corner dining nook with round wooden table and four stools in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/SktpJCC3fI1uKByt5FJQGAcanmzKAIYp2v5T-tEswmA/116/image.jpg"
    },
    {
      "id": "custom_4178fab5-d94e-4468-831c-7a9b7e6270ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-770d-77a9-9f6d-73df06e9ca18.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a bed, nightstand, dresser, and chevron-pattern curtains.",
        "public_id": "019cfb49-770d-77a9-9f6d-73df06e9ca18",
        "storage_key": "property/6767906449165631/019cfb49-770d-77a9-9f6d-73df06e9ca18.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Bright apartment bedroom with wood furniture, cozy bedding, and chevron curtains.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a bed, nightstand, dresser, and chevron-pattern curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/uWmcid_yO2YKapuJh7l4P4eiPkjWi9iU53NNLfWAUbE/116/image.jpg"
    },
    {
      "id": "custom_ffdff7bc-66e8-4166-b5c2-9907bd0473e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-7716-750c-9584-9eb06ce5d7d3.webp",
      "image_media": {
        "alt_text": "Apartment bathroom with sink, vanity, toilet, and a floral shower curtain.",
        "public_id": "019cfb49-7716-750c-9584-9eb06ce5d7d3",
        "storage_key": "property/6767906449165631/019cfb49-7716-750c-9584-9eb06ce5d7d3.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom featuring wood cabinets, beige countertop, and a shower/tub combo with floral curtain.",
      "link": "",
      "alt_text": "Apartment bathroom with sink, vanity, toilet, and a floral shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/aNw99bo6gpRRfJz4r4WhEjjCiYCRFq3nL-M6xw_2hi0/116/image.jpg"
    },
    {
      "id": "custom_80eab090-4097-483b-8710-03dc7d3a58e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-7955-72e8-b8cb-094714e8032b.webp",
      "image_media": {
        "alt_text": "Cozy living room with beige sofa, coffee table, and large window with sheer curtains.",
        "public_id": "019cfb49-7955-72e8-b8cb-094714e8032b",
        "storage_key": "property/6767906449165631/019cfb49-7955-72e8-b8cb-094714e8032b.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Apartment",
      "description": "Bright living room in a modern apartment with a beige sofa, decorative pillows, a wooden coffee table, and a large window with sheer curtains.",
      "link": "",
      "alt_text": "Cozy living room with beige sofa, coffee table, and large window with sheer curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/x2IzpPf4l2VlGPWFf6m9xXmLrCnbLbZa8T2HhwQVSyA/116/image.jpg"
    },
    {
      "id": "custom_898951fc-d049-453f-a556-6b0c05c9128a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d20af-e547-725a-b2fd-7a66cb0dd1f6.webp",
      "image_media": {
        "alt_text": "Aerial view of a downtown skyline with modern buildings and streets.",
        "public_id": "019d20af-e547-725a-b2fd-7a66cb0dd1f6",
        "storage_key": "property/6767906449165631/019d20af-e547-725a-b2fd-7a66cb0dd1f6.webp",
        "width": 1254,
        "height": 836
      },
      "title": "Lifestyle",
      "description": "Bird's-eye view of a downtown skyline with high-rise buildings, trees, and a grid of streets.",
      "link": "",
      "alt_text": "Aerial view of a downtown skyline with modern buildings and streets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165631%2F76967eed474d7ffc3bd8a8b9251f43d9.jpg"
    },
    {
      "id": "custom_67e44d1d-f4b4-486d-a76d-e9c844b68925",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d20af-f1d8-7268-9c4f-e6340abefe63.webp",
      "image_media": {
        "alt_text": "Close-up of a person holding a white travel mug beside a bicycle.",
        "public_id": "019d20af-f1d8-7268-9c4f-e6340abefe63",
        "storage_key": "property/6767906449165631/019d20af-f1d8-7268-9c4f-e6340abefe63.webp",
        "width": 698,
        "height": 797
      },
      "title": "Lifestyle",
      "description": "Lifestyle image of a person with a mug next to a bicycle, suggesting active, casual living at the property.",
      "link": "",
      "alt_text": "Close-up of a person holding a white travel mug beside a bicycle.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165631%2F301c52f434bc61b47e662744522cd5ea.webp"
    },
    {
      "id": "custom_452f1200-8fef-48b0-996a-24dfd0a36d3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d20af-f8d6-762e-8a62-d07b1360718a.webp",
      "image_media": {
        "alt_text": "Outdoor plaza with brick storefronts, planters, awnings, and pedestrians under a blue sky.",
        "public_id": "019d20af-f8d6-762e-8a62-d07b1360718a",
        "storage_key": "property/6767906449165631/019d20af-f8d6-762e-8a62-d07b1360718a.webp",
        "width": 788,
        "height": 469
      },
      "title": "Lifestyle",
      "description": "Outdoor shopping-style courtyard with storefronts, seating, and greenery in a multifamily community.",
      "link": "",
      "alt_text": "Outdoor plaza with brick storefronts, planters, awnings, and pedestrians under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://storage.googleapis.com/photo-gallery-conversions/5767906449162419%2F6767906449165631%2Fbfaeabed484fa12a5688bbfa30b49fcf.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_03f7f360-6678-476f-bf82-aaa4807c377e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2100 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Chain serving steaks and ribs in a casual setting featuring a jukebox and line dancers.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, chicken fried steak, and ribs, and the rolls with cinnamon butter are a highlight. They also highlight the friendly and accommodating staff, and the family-friendly atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-8788-70ff-a718-a653fcc9b5f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8788-70ff-a718-a653fcc9b5f5",
        "storage_key": "property/6767906449165631/019d2709-8788-70ff-a718-a653fcc9b5f5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/oklahoma-city-north-memorial-rd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3657567219942529703&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.6078943",
      "poi_longitude": "-97.5503319",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-755-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-bf26-728f-b490-95b579709fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bf26-728f-b490-95b579709fe3",
        "storage_key": "property/6767906449165631/019d2709-bf26-728f-b490-95b579709fe3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYzghGscsocRp5rJBgJKwjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_93e9cbbd-6a7b-4345-a48c-3a797e01d481",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Clark Crew BBQ",
      "poi_type": "Restaurants",
      "poi_address": "3510 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Casual establishment with a patio for pit-smoked beef brisket, ribs, pulled pork and more.",
      "poi_long_description": "Diners say this barbecue restaurant serves up delicious burnt ends, brisket, ribs, and sausage, with sides of mac and cheese, baked beans, and cornbread. They also highlight the friendly and attentive service, and the lively back patio with live music.\n\nSome reviews mention the parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-86d7-72dd-bc1a-36509ce4254c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-86d7-72dd-bc1a-36509ce4254c",
        "storage_key": "property/6767906449165631/019d2709-86d7-72dd-bc1a-36509ce4254c.webp",
        "width": 599,
        "height": 596
      },
      "poi_business_url": "http://www.clarkcrewbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3587788996052338906&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clark-crew-bbq",
      "poi_latitude": "35.5323986",
      "poi_longitude": "-97.5816496",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-724-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-bf26-728f-b490-95b579709fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bf26-728f-b490-95b579709fe3",
        "storage_key": "property/6767906449165631/019d2709-bf26-728f-b490-95b579709fe3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6r6_-4asocR2kjBPhVjyjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_27d0e791-ee79-49fa-ba50-7d44640ff184",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Louie's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "9401 Lake Hefner Pkwy, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Casual eatery offering burgers and other American eats at a location overlooking Lake Hefner.",
      "poi_long_description": "People say this bar and grill offers delicious burgers, fish tacos, and wraps, and they highlight the sweet potato fries and cherry cocktail. They also like the beautiful lake views, especially at sunset, the live music, and the outdoor patio.\n\nOther reviews mention the noise level can be distracting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-874b-77e3-bb46-249897a6be2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-874b-77e3-bb46-249897a6be2d",
        "storage_key": "property/6767906449165631/019d2709-874b-77e3-bb46-249897a6be2d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://louiesgrillandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13485773733165357309&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "louies-grill--bar",
      "poi_latitude": "35.5657821",
      "poi_longitude": "-97.5775183",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-751-2298",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-beee-700b-837d-4381a723e896.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-beee-700b-837d-4381a723e896",
        "storage_key": "property/6767906449165631/019d2709-beee-700b-837d-4381a723e896.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSzs7gwbsocR_ViddsIXJ7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_5f07e22b-4397-4207-a894-52fc176abe96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Meddys",
      "poi_type": "Restaurants",
      "poi_address": "9404 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious dishes like the Meddys Main Plate, hummus bowl, and garlic chicken, with generous portions and fresh, flavorful ingredients. They highlight the reasonable prices, casual and modern atmosphere, and the availability of outdoor seating and live music. They also like the friendly and attentive staff, and the quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-87f6-70b5-9242-ec08b031a0a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-87f6-70b5-9242-ec08b031a0a0",
        "storage_key": "property/6767906449165631/019d2709-87f6-70b5-9242-ec08b031a0a0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.meddys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10733599644329479405&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meddys",
      "poi_latitude": "35.56632889999999",
      "poi_longitude": "-97.5666625",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-546-1003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-bf26-728f-b490-95b579709fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bf26-728f-b490-95b579709fe3",
        "storage_key": "property/6767906449165631/019d2709-bf26-728f-b490-95b579709fe3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIS_1pD8bsocR7YyE6QFo9ZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_8e134ebb-0ec3-4a95-b4e7-dd9f6186e939",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Oklahoma City Incredible Pizza Company",
      "poi_type": "Restaurants",
      "poi_address": "5833 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Buffet dining as well as an arcade, laser tag arena and go-karts for kids' parties and other fun days out.",
      "poi_long_description": "Visitors say this pizza restaurant offers a buffet with a variety of food, including pizza, hot dogs, tacos, chicken, and a salad bar, as well as fun attractions like go-karts and laser tag. They like the friendly and helpful staff, the clean facilities, and the great value for families, with many mentioning it's a popular spot for birthday parties.\n\nSome reviews mention the buffet can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-8b49-77ad-959e-be3c1c748c7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8b49-77ad-959e-be3c1c748c7b",
        "storage_key": "property/6767906449165631/019d2709-8b49-77ad-959e-be3c1c748c7b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://incrediblepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7640346941500558065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-city-incredible-pizza-company",
      "poi_latitude": "35.5504818",
      "poi_longitude": "-97.6162357",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-728-8360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-bf26-728f-b490-95b579709fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bf26-728f-b490-95b579709fe3",
        "storage_key": "property/6767906449165631/019d2709-bf26-728f-b490-95b579709fe3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30Sq7dMEsocR8QriIBD3B2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_a3140431-4eb3-4db2-b6b8-490d75164f84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Quail Springs Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Shopping destination with a cinema, a food court, a kids' play area, and an arcade.",
      "poi_long_description": "People say this shopping center offers a variety of stores, a food court, a movie theater, and an arcade. They also highlight the fun atmosphere, the clean environment, and the good prices for the arcade and movies.\n\nOther reviews mention the food court can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-8c69-7756-b338-f20c3530b806.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8c69-7756-b338-f20c3530b806",
        "storage_key": "property/6767906449165631/019d2709-8c69-7756-b338-f20c3530b806.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.quailspringsmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=254102542958583292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quail-springs-mall",
      "poi_latitude": "35.6130282",
      "poi_longitude": "-97.5584437",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-254-4979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-bef0-7605-8d8b-439d26999105.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bef0-7605-8d8b-439d26999105",
        "storage_key": "property/6767906449165631/019d2709-bef0-7605-8d8b-439d26999105.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS_2JfGccsocR_N2RoerAhgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6d3836f3-06c7-4fa2-9848-86f4883b25bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "3040 NW 59th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Large hardware chain stocked with a wide selection of tools, lumber and building materials, plus appliances.",
      "poi_long_description": "People say this home improvement store usually has what they need. They also highlight the staff is friendly and helpful.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-8bde-73ea-8bad-f2f5c25bf9fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8bde-73ea-8bad-f2f5c25bf9fd",
        "storage_key": "property/6767906449165631/019d2709-8bde-73ea-8bad-f2f5c25bf9fd.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/N-Oklahoma-City/OK/Oklahoma-City/73112/3902?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8923094349114202389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.5313564",
      "poi_longitude": "-97.5691642",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-843-5008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-bef0-7605-8d8b-439d26999105.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bef0-7605-8d8b-439d26999105",
        "storage_key": "property/6767906449165631/019d2709-bef0-7605-8d8b-439d26999105.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGSHGIfYasocRFVk_sAgz1Xs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_ce124fe7-1ea2-4e51-8bab-f6ade9c1eabb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2400 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Home improvement chain with a wide selection of tools, appliances and paint for DIYers.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-8c98-732a-befe-98822c064660.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8c98-732a-befe-98822c064660",
        "storage_key": "property/6767906449165631/019d2709-8c98-732a-befe-98822c064660.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Oklahoma-City/0535?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-535-_-na-_-0-_-0&y_source=1_MTE4MzI1OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9854502234558219169&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "35.6067382",
      "poi_longitude": "-97.5561463",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-936-2060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-bef0-7605-8d8b-439d26999105.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bef0-7605-8d8b-439d26999105",
        "storage_key": "property/6767906449165631/019d2709-bef0-7605-8d8b-439d26999105.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ80ErRm8csocRocMiKZI5wog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_25518b87-1472-4f8f-b384-c34e05194bfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6410 N May Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Casual grocery chain selling organic, gluten-free and vegan foods, plus produce and packaged goods.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, organic foods, and healthy options. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-9093-75ac-8890-b4f1c63cc469.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9093-75ac-8890-b4f1c63cc469",
        "storage_key": "property/6767906449165631/019d2709-9093-75ac-8890-b4f1c63cc469.webp",
        "width": 958,
        "height": 1280
      },
      "poi_business_url": "https://sprouts.com/store/ok/oklahoma-city/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=15265666738450826751&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "35.5374999",
      "poi_longitude": "-97.5647576",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-879-9989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-bf3c-71bf-830b-a804ae81b371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bf3c-71bf-830b-a804ae81b371",
        "storage_key": "property/6767906449165631/019d2709-bf3c-71bf-830b-a804ae81b371.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMSbEc1casocR_4XbhASL2tM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_59b41c45-12a0-48c4-b705-22355053f0fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "6100 N May Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Chain selling books and magazines, plus toys and gifts.",
      "poi_long_description": "People say this bookstore offers a huge selection of books, puzzles, music, and toys, and has a Starbucks. They highlight the clean, organized, and quiet atmosphere, and the friendly and helpful staff. They also like the convenient parking and the train table in the kids' section.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-918d-70b9-8256-91cbcca5b8ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-918d-70b9-8256-91cbcca5b8ba",
        "storage_key": "property/6767906449165631/019d2709-918d-70b9-8256-91cbcca5b8ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2694",
      "poi_directions_map_url": "https://maps.google.com/?cid=986591179468385464&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barnes--noble",
      "poi_latitude": "35.5331139",
      "poi_longitude": "-97.5647667",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-843-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-bef0-7605-8d8b-439d26999105.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bef0-7605-8d8b-439d26999105",
        "storage_key": "property/6767906449165631/019d2709-bef0-7605-8d8b-439d26999105.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvczS4lgasocRuCy_VnMTsQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_b2c2a625-7510-40c4-9e19-663c7d94bf24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Southern Nazarene University",
      "poi_type": "Education",
      "poi_address": "6729 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-90f8-767b-bb74-c9f81ede3249.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-90f8-767b-bb74-c9f81ede3249",
        "storage_key": "property/6767906449165631/019d2709-90f8-767b-bb74-c9f81ede3249.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2990625230431240297&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southern-nazarene-university",
      "poi_latitude": "35.5135594",
      "poi_longitude": "-97.6288124",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-789-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c2e1-76ea-bcfa-38157f7621f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2e1-76ea-bcfa-38157f7621f5",
        "storage_key": "property/6767906449165631/019d2709-c2e1-76ea-bcfa-38157f7621f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHYsS70IFsocRacAsVM3VgCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c1ab9da3-9ca0-4bd5-a1d1-e425007f9561",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Patience S. Latting Northwest Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "5600 NW 122nd St, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Modern, welcoming library featuring kid-friendly activities and patios, plus a large selection of books.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-90e7-753c-95c8-09618741f77a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-90e7-753c-95c8-09618741f77a",
        "storage_key": "property/6767906449165631/019d2709-90e7-753c-95c8-09618741f77a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6566230327670178026&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "patience-s-latting-northwest-library---metropolitan-library-system",
      "poi_latitude": "35.5941759",
      "poi_longitude": "-97.6179217",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-606-3580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c2e1-76ea-bcfa-38157f7621f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2e1-76ea-bcfa-38157f7621f5",
        "storage_key": "property/6767906449165631/019d2709-c2e1-76ea-bcfa-38157f7621f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkacMZVEDsocR6oAtkrHvH1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_e9d63e34-de19-4e74-bbec-56a3716ac21b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Bethany Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "6700 NW 35th St, Bethany, OK 73008, USA",
      "poi_short_description": "Public library offering kid-friendly activities, meeting rooms, and other resources.",
      "poi_long_description": "People say this public library offers a diverse selection of books and a variety of activities for all ages. They highlight the cozy atmosphere and the availability of meeting rooms. They also like the helpful and attentive staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-95df-7679-b8f5-7803b4d4db19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-95df-7679-b8f5-7803b4d4db19",
        "storage_key": "property/6767906449165631/019d2709-95df-7679-b8f5-7803b4d4db19.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=15531442417609680617&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethany-library---metropolitan-library-system",
      "poi_latitude": "35.5062789",
      "poi_longitude": "-97.6316452",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-789-8363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c2e1-76ea-bcfa-38157f7621f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2e1-76ea-bcfa-38157f7621f5",
        "storage_key": "property/6767906449165631/019d2709-c2e1-76ea-bcfa-38157f7621f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV4NBRVwFsocR6SYP95bEitc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_fafd43df-b2d9-4045-bd17-4ebcf192acc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "The Village Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "10307 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Public library featuring DVDs and quiet areas for study and reading.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-96e4-7384-b9ef-d67c63c77990.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-96e4-7384-b9ef-d67c63c77990",
        "storage_key": "property/6767906449165631/019d2709-96e4-7384-b9ef-d67c63c77990.webp",
        "width": 1280,
        "height": 382
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6591062255135426801&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-village-library---metropolitan-library-system",
      "poi_latitude": "35.5755065",
      "poi_longitude": "-97.5498468",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-755-0710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c2e1-76ea-bcfa-38157f7621f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2e1-76ea-bcfa-38157f7621f5",
        "storage_key": "property/6767906449165631/019d2709-c2e1-76ea-bcfa-38157f7621f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt5LnnJMbsocR8QjVOTMoeFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_a878d80c-dd29-42c9-881b-1ccbab1b9554",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Blue Zoo Aquarium Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd Suite 125A, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Mall-based attraction featuring sharks, stingrays, snakes and other marine life plus a playground for kids.",
      "poi_long_description": "People say this aquarium offers a variety of interactive experiences, including stingray petting and feeding, bird feeding, and a mermaid show. They also highlight the family-friendly atmosphere, the friendly and helpful staff, and the fun play area for children.\n\nSome reviews mention the aquarium can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-9631-7061-937d-3dfb977a6444.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9631-7061-937d-3dfb977a6444",
        "storage_key": "property/6767906449165631/019d2709-9631-7061-937d-3dfb977a6444.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oklahomacity.bluezoo.us/?utm_source=google&utm_medium=organic&utm_campaign=Google+Business+Profile+-+OKC",
      "poi_directions_map_url": "https://maps.google.com/?cid=5242468447430833348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-zoo-aquarium-oklahoma-city",
      "poi_latitude": "35.6125884",
      "poi_longitude": "-97.5573925",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 208-912-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4zKmxcdsocRxPRO80b9wEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_f1a7ca04-d646-4270-9946-cc6085afe197",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "SNU Football Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Bethany, OK 73008, USA",
      "poi_short_description": "Stadium offering a field and a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-9723-743a-8a4d-f9d201aec34d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9723-743a-8a4d-f9d201aec34d",
        "storage_key": "property/6767906449165631/019d2709-9723-743a-8a4d-f9d201aec34d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://snuathletics.com/facilities/snu-football-stadium/1",
      "poi_directions_map_url": "https://maps.google.com/?cid=14871021148287990153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "snu-football-stadium",
      "poi_latitude": "35.5210386",
      "poi_longitude": "-97.661832",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c2ee-716e-afdb-e91175a095e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2ee-716e-afdb-e91175a095e8",
        "storage_key": "property/6767906449165631/019d2709-c2ee-716e-afdb-e91175a095e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFyihiaEFsocRifkGv_F6YM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_6ea6e7c2-8c89-439d-9ee9-78ba556a7ab8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Lake Overholser Iron Bridge",
      "poi_type": "Entertainment",
      "poi_address": "8703-8709 Overholser Dr, Bethany, OK 73008, USA",
      "poi_short_description": "Historic bridge on the former Route 66, still open to traffic, with scenic views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-9aee-768b-8212-8307e69e3627.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9aee-768b-8212-8307e69e3627",
        "storage_key": "property/6767906449165631/019d2709-9aee-768b-8212-8307e69e3627.webp",
        "width": 720,
        "height": 491
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1592759798430792050&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-overholser-iron-bridge",
      "poi_latitude": "35.5146149",
      "poi_longitude": "-97.6638523",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQwMnJkFsocRcnn9DZmeGhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_b6e10279-bff2-4f57-902f-988de04e79d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Oklahoma Museum of Flying",
      "poi_type": "Entertainment",
      "poi_address": "7110 Millionaire Dr, Bethany, OK 73008, USA",
      "poi_short_description": "Volunteer-powered locale for seeing and touching real planes plus learning about their history and mechanics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-9a9d-77a9-9136-67802e410ed4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9a9d-77a9-9136-67802e410ed4",
        "storage_key": "property/6767906449165631/019d2709-9a9d-77a9-9136-67802e410ed4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/oklahomamuseumofflying/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7234880537762503548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-museum-of-flying",
      "poi_latitude": "35.5337967",
      "poi_longitude": "-97.6380221",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c36a-73cf-869c-e530a42ee5dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c36a-73cf-869c-e530a42ee5dc",
        "storage_key": "property/6767906449165631/019d2709-c36a-73cf-869c-e530a42ee5dc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5c3VjhkFsocRfJu4XYR1Z2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_21cfb714-81dd-4aa1-82c5-004322aa5ae0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Pirate Stadium",
      "poi_type": "Entertainment",
      "poi_address": "5300 NW 50th St, Oklahoma City, OK 73122, USA",
      "poi_short_description": "Venue used for graduation, track meets, and games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-9bf7-7030-b70b-931031923956.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9bf7-7030-b70b-931031923956",
        "storage_key": "property/6767906449165631/019d2709-9bf7-7030-b70b-931031923956.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://stadiumconnection.com/ok/stadium.php?id=2852",
      "poi_directions_map_url": "https://maps.google.com/?cid=11523176646670315445&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pirate-stadium",
      "poi_latitude": "35.5216132",
      "poi_longitude": "-97.6066534",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-789-7101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c2ee-716e-afdb-e91175a095e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2ee-716e-afdb-e91175a095e8",
        "storage_key": "property/6767906449165631/019d2709-c2ee-716e-afdb-e91175a095e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR1OWhrUasocRtW_clBuM6p8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_e523cb46-dad4-4d49-ab2c-4a537f1bbb2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "2563 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers excellent tennis courts. They also highlight the facility has many pools and pickleball courts.\n\nOther reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-9c59-760a-b4e3-6fc50e7c40a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9c59-760a-b4e3-6fc50e7c40a0",
        "storage_key": "property/6767906449165631/019d2709-9c59-760a-b4e3-6fc50e7c40a0.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/oklahoma-city.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=13614994550085944548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "35.61423510000001",
      "poi_longitude": "-97.5602129",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-832-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWAnM3kdsocR5ITAcGgt8rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b859fd69-2d2c-4b03-9e33-2248b9868455",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Crunch Fitness - Oklahoma City, OK",
      "poi_type": "Health and Wellness",
      "poi_address": "12508 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Gym, part of a chain, offering yoga, cardio and weights rooms, and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of group fitness classes, modern equipment, and childcare, and has a friendly and motivating atmosphere.\n\nOther reviews mention membership cancellation can be difficult and there can be hidden fees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-9f79-714f-96ca-81b1c44577a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9f79-714f-96ca-81b1c44577a3",
        "storage_key": "property/6767906449165631/019d2709-9f79-714f-96ca-81b1c44577a3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/quail-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097941148085874568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---oklahoma-city-ok",
      "poi_latitude": "35.5969373",
      "poi_longitude": "-97.565988",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-497-8160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Z8NgOkdsocRiG_leCo9oFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6fc40fe8-c35a-425c-9f4e-b6f1fb1934d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Neel Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2700 N MacArthur Blvd, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-a100-717e-9bfc-858200563bae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a100-717e-9bfc-858200563bae",
        "storage_key": "property/6767906449165631/019d2709-a100-717e-9bfc-858200563bae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://neel.vet/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4132737864806100553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "neel-veterinary-hospital",
      "poi_latitude": "35.4972708",
      "poi_longitude": "-97.6183664",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-947-8387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYV66BPkPsocRSe6SHTFvWjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_4b1d0bdc-8880-409e-9251-ad412cd0e6a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Crunch Fitness - OKC Northwest",
      "poi_type": "Health and Wellness",
      "poi_address": "8490 Northwest Expy, Oklahoma City, OK 73162, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, weight machines, and tanning beds, and provides childcare services.\n\nOther reviews mention the music can be loud and the cancellation policy can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-a0e9-7547-96b8-b63b6d108e4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a0e9-7547-96b8-b63b6d108e4c",
        "storage_key": "property/6767906449165631/019d2709-a0e9-7547-96b8-b63b6d108e4c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/okc-northwest",
      "poi_directions_map_url": "https://maps.google.com/?cid=6916258324870179385&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---okc-northwest",
      "poi_latitude": "35.56632099999999",
      "poi_longitude": "-97.6628647",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-267-6282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWtxzOQFsocROaq5dE18-18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e01dcecf-9086-4696-aa73-5a81a7cd6019",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "TB Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-a0a9-7582-8fb0-032c0dd3c0a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a0a9-7582-8fb0-032c0dd3c0a6",
        "storage_key": "property/6767906449165631/019d2709-a0a9-7582-8fb0-032c0dd3c0a6.webp",
        "width": 1280,
        "height": 730
      },
      "poi_business_url": "https://tbfitclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12558554567901756546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tb-fitness-club",
      "poi_latitude": "35.5816564",
      "poi_longitude": "-97.5782735",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-849-9173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfqhdqYbsocRgrwkaNfySK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_50072928-1f36-473c-b700-319bb5e11dfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Colaw Fitness of Oklahoma City Gyms",
      "poi_type": "Health and Wellness",
      "poi_address": "3645 NW 39th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Positive gym, with exercise equipment, tanning beds and massage chairs – plus spiritual wellness.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, tanning beds, and massage chairs. They highlight the affordable membership options, clean facilities, and welcoming atmosphere. They also like the friendly, helpful, and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-a38e-71ad-979a-627dcbff65f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a38e-71ad-979a-627dcbff65f1",
        "storage_key": "property/6767906449165631/019d2709-a38e-71ad-979a-627dcbff65f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://colawfitness.com/gyms/oklahoma-city-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8355987367554066829&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "colaw-fitness-of-oklahoma-city-gyms",
      "poi_latitude": "35.5128276",
      "poi_longitude": "-97.5823903",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-838-1644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0nvVDcbsocRjSm2Jj1u9nM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_51cdf507-502c-4037-95f6-ab67c517ec23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Bethany YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3400 N Mueller Ave, Bethany, OK 73008, USA",
      "poi_short_description": "Chain fitness center offering amenities such as a pool, basketball courts, and water aerobics classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-a56c-75ea-8718-e015509af1f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a56c-75ea-8718-e015509af1f7",
        "storage_key": "property/6767906449165631/019d2709-a56c-75ea-8718-e015509af1f7.webp",
        "width": 994,
        "height": 533
      },
      "poi_business_url": "https://ymcaokc.org/branches/bethany/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8306823524238509196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethany-ymca",
      "poi_latitude": "35.5051032",
      "poi_longitude": "-97.6316419",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-789-0231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9wBj710FsocRjEQY3vvDR3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9d72a842-6bc9-4e6e-9a2b-9b05aa0742e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "2340 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Beauty retailer offering cosmetics, fragrances, and skin and hair care products, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-a6f8-77ae-a6ec-dc41c94938a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a6f8-77ae-a6ec-dc41c94938a9",
        "storage_key": "property/6767906449165631/019d2709-a6f8-77ae-a6ec-dc41c94938a9.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/oklahoma-city-ok-128",
      "poi_directions_map_url": "https://maps.google.com/?cid=17751417342740012859&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.606929",
      "poi_longitude": "-97.553605",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-302-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmaQHR2kcsocROx-6rQW0WfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_5fccaf53-b310-4b2a-975e-9e73088c0a7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10908 N May Ave A, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Spacious gym with a hydro-massage area and tanning beds, plus classes and machines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-a5b8-75bc-a51d-5bc61bafa26c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a5b8-75bc-a51d-5bc61bafa26c",
        "storage_key": "property/6767906449165631/019d2709-a5b8-75bc-a51d-5bc61bafa26c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/oklahoma-city-quail-plaza-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=3477844169655460775&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.5807984",
      "poi_longitude": "-97.5653315",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-697-1750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeXhK4IIbsocRpyN6jNjIQzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c6534e32-699b-4d64-992d-be2ea9b6be7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "INTEGRIS Health Baptist Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-a7e7-7336-96aa-316d058d88e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a7e7-7336-96aa-316d058d88e1",
        "storage_key": "property/6767906449165631/019d2709-a7e7-7336-96aa-316d058d88e1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://baptist.integrisok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369483754313068495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-baptist-medical-center",
      "poi_latitude": "35.5290386",
      "poi_longitude": "-97.5764421",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-949-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c6c1-7134-87fa-77ec2269ff54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c6c1-7134-87fa-77ec2269ff54",
        "storage_key": "property/6767906449165631/019d2709-c6c1-7134-87fa-77ec2269ff54.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX5SM_IasocRz68D4IjO548",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_196bf359-ac78-49cc-96ff-64d2b9eed0e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Mercy Hospital Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "4300 W Memorial Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-a9da-740b-b034-133cb80030c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a9da-740b-b034-133cb80030c5",
        "storage_key": "property/6767906449165631/019d2709-a9da-740b-b034-133cb80030c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-oklahoma-city?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=West&utm_content=website&y_source=1_MTI5OTY2MDItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9313836111055257082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-hospital-oklahoma-city",
      "poi_latitude": "35.607198",
      "poi_longitude": "-97.600529",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-755-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c6c1-7134-87fa-77ec2269ff54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c6c1-7134-87fa-77ec2269ff54",
        "storage_key": "property/6767906449165631/019d2709-c6c1-7134-87fa-77ec2269ff54.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-YSHLkcsocR-n2nn5hkQYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ee7b865f-178f-4045-bc0a-4bcf5b05be83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Martin Park Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5000 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Kid-friendly nature preserve with playgrounds and trails, plus deer and turtles.",
      "poi_long_description": "People say this park offers beautiful trails, a playground, and opportunities to see wildlife like deer, turtles, and birds. They highlight the serene and peaceful atmosphere, and the well-maintained grounds. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-abe1-7688-98fd-bf819a9dfddd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-abe1-7688-98fd-bf819a9dfddd",
        "storage_key": "property/6767906449165631/019d2709-abe1-7688-98fd-bf819a9dfddd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/martin-park-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9715724291787303274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-park-nature-center",
      "poi_latitude": "35.6090059",
      "poi_longitude": "-97.6090052",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-297-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c72c-7098-b76a-f9d78b8727b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c72c-7098-b76a-f9d78b8727b2",
        "storage_key": "property/6767906449165631/019d2709-c72c-7098-b76a-f9d78b8727b2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71CwarQcsocRaqmda8Qv1YY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3e80a800-4d31-42d5-bac5-511cb5181ffe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Stars And Stripes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3701 S Lake Hefner Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Relaxed, family-friendly park bordering Lake Hefner offering a skatepark, plus playgrounds.",
      "poi_long_description": "People say this city park offers a large playground, walking trails, and panoramic views of the lake. They highlight the numerous play areas, tables, and BBQ spaces, as well as the decent parking and proximity to the lake. They also like the ability to build sandcastles and watch boats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-ac33-77ea-9ade-94bf9e318292.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ac33-77ea-9ade-94bf9e318292",
        "storage_key": "property/6767906449165631/019d2709-ac33-77ea-9ade-94bf9e318292.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/34/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=16012526237037472583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stars-and-stripes-park",
      "poi_latitude": "35.5500436",
      "poi_longitude": "-97.5822759",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c72c-7098-b76a-f9d78b8727b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c72c-7098-b76a-f9d78b8727b2",
        "storage_key": "property/6767906449165631/019d2709-c72c-7098-b76a-f9d78b8727b2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2tmaBwbsocRR6s9S8brN94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0432e7e1-a6f3-4c1a-8425-d51e8ada6cf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Bluff Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11301 N Meridian Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "A large green space featuring walking trails, picnic spots and a playground.",
      "poi_long_description": "Visitors say this park offers well-maintained walking trails, paved trails, and bike trails, and they praise the abundance of wildlife, especially deer. They also highlight the peaceful atmosphere, ideal for nature walks, jogging, or simply relaxing in the outdoors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-ac8b-71b8-8421-d2b4f36beb5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ac8b-71b8-8421-d2b4f36beb5c",
        "storage_key": "property/6767906449165631/019d2709-ac8b-71b8-8421-d2b4f36beb5c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/8/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=1559565554729670411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluff-creek-park",
      "poi_latitude": "35.584442",
      "poi_longitude": "-97.6065873",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-837-7995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c72c-7098-b76a-f9d78b8727b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c72c-7098-b76a-f9d78b8727b2",
        "storage_key": "property/6767906449165631/019d2709-c72c-7098-b76a-f9d78b8727b2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3zaRlYbsocRC9eY7ZuwpBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_62b75231-7e72-4159-9f29-46a2393ecbb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Dolese Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5105 NW 50th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Park with picnic tables, a playground, a paved cycling trail, disc golf course, and facilities for baseball and fishing.",
      "poi_long_description": "People say this park offers a disc golf course, trails, a playground, and a pond for fishing. They highlight the beautiful scenery, the well-maintained trails, and the friendly people. They also like the calming atmosphere and the ample space for various activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-aed6-741f-836e-c10e5fb7c809.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-aed6-741f-836e-c10e5fb7c809",
        "storage_key": "property/6767906449165631/019d2709-aed6-741f-836e-c10e5fb7c809.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15736370327146326173&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dolese-park",
      "poi_latitude": "35.52624369999999",
      "poi_longitude": "-97.6055628",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c72c-7098-b76a-f9d78b8727b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c72c-7098-b76a-f9d78b8727b2",
        "storage_key": "property/6767906449165631/019d2709-c72c-7098-b76a-f9d78b8727b2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcf9-e8kasocRneiNC3DRYto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a4cc6532-e8f2-44e1-b42f-b6f0d35958ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Stinchcomb Wildlife Refuge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5100 N Stinchcomb Ave, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Lush nature area popular for hiking, kayaking, fishing and mountain biking, as well as for its wildlife.",
      "poi_long_description": "People say this wildlife refuge offers hiking trails, access to the river, and opportunities for wildlife viewing. They highlight the beautiful scenery, the variety of trails, and the chance to experience nature. They also like the opportunities for paddling and mountain biking. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-b102-737f-b8aa-857cf200f343.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b102-737f-b8aa-857cf200f343",
        "storage_key": "property/6767906449165631/019d2709-b102-737f-b8aa-857cf200f343.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=16862425980734090786&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stinchcomb-wildlife-refuge",
      "poi_latitude": "35.5227424",
      "poi_longitude": "-97.6633716",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-297-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c72c-7098-b76a-f9d78b8727b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c72c-7098-b76a-f9d78b8727b2",
        "storage_key": "property/6767906449165631/019d2709-c72c-7098-b76a-f9d78b8727b2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ85Pzk84FsocRIi75qBZfA-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_9129e939-5cff-4932-a48b-bfa5a12589f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Wiley Post Airport-PWA",
      "poi_type": "Transportation & Transit",
      "poi_address": "5915 Philip J Rhoads Ave, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-b161-7119-a71b-64ebafaa85ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b161-7119-a71b-64ebafaa85ed",
        "storage_key": "property/6767906449165631/019d2709-b161-7119-a71b-64ebafaa85ed.webp",
        "width": 1280,
        "height": 1013
      },
      "poi_business_url": "http://www.wileypostairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17919166834402155680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wiley-post-airport-pwa",
      "poi_latitude": "35.5307445",
      "poi_longitude": "-97.6430208",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-316-4061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c790-752c-a6b9-216815ff7f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c790-752c-a6b9-216815ff7f7f",
        "storage_key": "property/6767906449165631/019d2709-c790-752c-a6b9-216815ff7f7f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_0-vGAMFsocRoFyAy0urrfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_23ab38e5-07a4-4ec6-8955-550e7d47b59b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Sundance Airport KHSD",
      "poi_type": "Transportation & Transit",
      "poi_address": "13000 N Sara Rd, Yukon, OK 73099, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-b179-75ac-81d8-136b5ff87daf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b179-75ac-81d8-136b5ff87daf",
        "storage_key": "property/6767906449165631/019d2709-b179-75ac-81d8-136b5ff87daf.webp",
        "width": 1280,
        "height": 478
      },
      "poi_business_url": "http://sundanceairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1335938299321620831&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sundance-airport-khsd",
      "poi_latitude": "35.601503",
      "poi_longitude": "-97.7069306",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-373-3886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c790-752c-a6b9-216815ff7f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c790-752c-a6b9-216815ff7f7f",
        "storage_key": "property/6767906449165631/019d2709-c790-752c-a6b9-216815ff7f7f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6eH4NUUBsocRX5nnHM40ihI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_99af128a-c86b-4ccd-8209-2c07b3e193af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Jetset FBO",
      "poi_type": "Transportation & Transit",
      "poi_address": "7220 NW 63rd St, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-b36b-7548-ba89-64e7cc4fdb73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b36b-7548-ba89-64e7cc4fdb73",
        "storage_key": "property/6767906449165631/019d2709-b36b-7548-ba89-64e7cc4fdb73.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.jetsetfbo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=522519284200811341&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jetset-fbo",
      "poi_latitude": "35.5368188",
      "poi_longitude": "-97.6412624",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-888-8684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c790-752c-a6b9-216815ff7f7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c790-752c-a6b9-216815ff7f7f",
        "storage_key": "property/6767906449165631/019d2709-c790-752c-a6b9-216815ff7f7f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1b0wrcFsocRTasUQ4VcQAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_6cf1f24a-1d53-469d-8731-7cdbd1b3f144",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Costco Member Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14501 Bogert Pkwy, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-b6bc-73f3-9949-1c1918daaa9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b6bc-73f3-9949-1c1918daaa9d",
        "storage_key": "property/6767906449165631/019d2709-b6bc-73f3-9949-1c1918daaa9d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3497496067160567460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "costco-member-service-center",
      "poi_latitude": "35.6183037",
      "poi_longitude": "-97.5748651",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX18i7nkdsocRpG5ufiSaiTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_bba8ccbe-8dc0-48b3-8f81-78563c70c06b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Love's South Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 Vineyard Blvd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-b608-74c0-ba0d-d0c0eef08f60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b608-74c0-ba0d-d0c0eef08f60",
        "storage_key": "property/6767906449165631/019d2709-b608-74c0-ba0d-d0c0eef08f60.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4360911662846330364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-south-building",
      "poi_latitude": "35.5769306",
      "poi_longitude": "-97.5501889",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfjgpJsbsocR_EXQYA0ShTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2bcad677-a8ea-481e-bd58-5f0191bea812",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Express Employment International",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9701 Boardwalk Blvd, Oklahoma City, OK 73162, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-b701-76bc-92a8-f3461b2b1258.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b701-76bc-92a8-f3461b2b1258",
        "storage_key": "property/6767906449165631/019d2709-b701-76bc-92a8-f3461b2b1258.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.expresspros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=92586903052956857&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "express-employment-international",
      "poi_latitude": "35.56707",
      "poi_longitude": "-97.666693",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-840-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6z8UW8EsocRuTRTO0zvSAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5f0dee98-27cb-465f-ab7e-c40af39d1601",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Love's Corporate - Building 50",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3601 NW 63rd St, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-b8a4-7306-a3eb-92482057388d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b8a4-7306-a3eb-92482057388d",
        "storage_key": "property/6767906449165631/019d2709-b8a4-7306-a3eb-92482057388d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4599439798442847940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---building-50",
      "poi_latitude": "35.5374849",
      "poi_longitude": "-97.5809021",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8bq4uQasocRxO76tyB-1D8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8eac51a1-c3a7-4466-915e-e8b3eeb9f048",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "MidFirst Bank Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11001 N Rockwell Ave, Oklahoma City, OK 73162, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-baf6-742e-bfa9-527b0d785594.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-baf6-742e-bfa9-527b0d785594",
        "storage_key": "property/6767906449165631/019d2709-baf6-742e-bfa9-527b0d785594.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.midfirst.com/?utm_source=Google&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=6366879175465188752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "midfirst-bank-corporate-office",
      "poi_latitude": "35.5812539",
      "poi_longitude": "-97.6401501",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-767-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c3f2-75b8-a67f-bd46cc9796f4",
        "storage_key": "property/6767906449165631/019d2709-c3f2-75b8-a67f-bd46cc9796f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE4lKIhQFsocRkD1vfeCyW1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_618632e3-79c5-4966-a1fb-4e1f0a6f1151",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Oklahoma City University",
      "poi_type": "Education",
      "poi_address": "2501 N Blackwelder Ave, Oklahoma City, OK 73106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-3618-70fa-9a0a-caf6218bcab9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3618-70fa-9a0a-caf6218bcab9",
        "storage_key": "property/6767906449165631/019d7913-3618-70fa-9a0a-caf6218bcab9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=411899583880737593&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-university",
      "poi_latitude": "35.4954082",
      "poi_longitude": "-97.540768",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 6 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 405-208-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d90-7373-a8a2-6df39c31b716",
        "storage_key": "property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe7zZY6MQsocRObNXPH1ctwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ce273a4b-a169-48ae-aed9-6c470952d38c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Ralph Downs Elementary School",
      "poi_type": "Education",
      "poi_address": "7501 W Hefner Rd, Oklahoma City, OK 73162, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://downs.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17676083283797892376&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ralph-downs-elementary-school",
      "poi_latitude": "35.5809392",
      "poi_longitude": "-97.6464415",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-721-4431",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d90-7373-a8a2-6df39c31b716",
        "storage_key": "property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-zjDqYQEsocRGF3-PhgQTvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a3e3a4a0-9087-44d9-a534-613a5973a62d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Kenneth Cooper Middle",
      "poi_type": "Education",
      "poi_address": "8001 River Bend Blvd, Oklahoma City, OK 73132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://cooper.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16085240058689467307&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kenneth-cooper-middle",
      "poi_latitude": "35.5428945",
      "poi_longitude": "-97.6561407",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-720-9887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d90-7373-a8a2-6df39c31b716",
        "storage_key": "property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi-uT-_8EsocRq7MRMZxAOt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5380926d-e20c-4c3b-a044-f35c831760ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Putnam City North High School",
      "poi_type": "Education",
      "poi_address": "11800 N Rockwell Ave, Oklahoma City, OK 73162, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019dbbe7-8b06-744f-b139-31b31cfa244b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe7-8b06-744f-b139-31b31cfa244b",
        "storage_key": "property/6767906449165631/019dbbe7-8b06-744f-b139-31b31cfa244b.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://pcnorth.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10895318835090211107&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "putnam-city-north-high-school",
      "poi_latitude": "35.5891349",
      "poi_longitude": "-97.6368418",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-722-4220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d90-7373-a8a2-6df39c31b716",
        "storage_key": "property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-ZkjjmADsocRI8EsMMHyM5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_415d644d-577a-4c67-9fef-6d4184bd3c21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Francis Tuttle Technology Center - Rockwell Campus",
      "poi_type": "Education",
      "poi_address": "12777 N Rockwell Ave, Oklahoma City, OK 73142, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-2929-743b-98ac-a14b9bc51b2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2929-743b-98ac-a14b9bc51b2f",
        "storage_key": "property/6767906449165631/019d7913-2929-743b-98ac-a14b9bc51b2f.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.francistuttle.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6888824651484980707&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "francis-tuttle-technology-center-rockwell-campus",
      "poi_latitude": "35.6005273",
      "poi_longitude": "-97.63997",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-717-7799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d90-7373-a8a2-6df39c31b716",
        "storage_key": "property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_XsrK2kDsocR42W3n4UFml8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_408e6cf3-2348-4697-a343-bc25287c4970",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Harvest Hills Elementary School",
      "poi_type": "Education",
      "poi_address": "8201 NW 104th St, Oklahoma City, OK 73162, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-366d-71fe-af27-d2ca3a0f0880.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-366d-71fe-af27-d2ca3a0f0880",
        "storage_key": "property/6767906449165631/019d7913-366d-71fe-af27-d2ca3a0f0880.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "https://harvesthills.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14172348023960517067&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "harvest-hills-elementary-school",
      "poi_latitude": "35.57638439999999",
      "poi_longitude": "-97.6603915",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-721-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d90-7373-a8a2-6df39c31b716",
        "storage_key": "property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfzcsf3sEsocRyzlggXBLrsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_003399e9-9e01-4d26-8290-f7dd777450ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Hefner Middle School",
      "poi_type": "Education",
      "poi_address": "8400 N MacArthur Blvd, Oklahoma City, OK 73132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-2dc3-70ba-b7d6-f72065fd96ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2dc3-70ba-b7d6-f72065fd96ff",
        "storage_key": "property/6767906449165631/019d7913-2dc3-70ba-b7d6-f72065fd96ff.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://hefner.putnamcityschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3061661222022488476&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hefner-middle-school",
      "poi_latitude": "35.557427",
      "poi_longitude": "-97.6193703",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-721-2411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d90-7373-a8a2-6df39c31b716",
        "storage_key": "property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsWfEvs8EsocRnCE9-ag0fSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4b02d145-27d1-4437-8b47-cd93d1cfc5c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "University of Oklahoma",
      "poi_type": "Education",
      "poi_address": "3213 N Youngs Blvd, Oklahoma City, OK 73112, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8456061943140191052&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "university-of-oklahoma",
      "poi_latitude": "35.5028738",
      "poi_longitude": "-97.55237710000002",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d90-7373-a8a2-6df39c31b716",
        "storage_key": "property/6767906449165631/019cfb49-0d90-7373-a8a2-6df39c31b716.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI629RwARsocRTAuS_4j3WXU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3ec0387a-fbec-435e-9d7d-569267e53b0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "The Garage Burgers & Beer",
      "poi_type": "Restaurants",
      "poi_address": "6900 NW 122nd St, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Trendy bar with TV sports & games, known for inventive gourmet burgers, tacos & hot dogs.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, including bison burgers, and loaded queso. They also highlight the fun atmosphere, decent beer selection, and attentive staff.\n\nSome reviews mention the orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-2f69-727c-be89-cf7b1527fedb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2f69-727c-be89-cf7b1527fedb",
        "storage_key": "property/6767906449165631/019d7913-2f69-727c-be89-cf7b1527fedb.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "http://eatatthegarage.com/locations/the-garage-rockwell/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7470076178638343110&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-garage-burgers-beer",
      "poi_latitude": "35.5941438",
      "poi_longitude": "-97.6367409",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-603-3080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d9f-7780-8fef-fe5be86a69f0",
        "storage_key": "property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZwMGVGYDsocRxovY0LQKq2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_711c739a-743a-4971-888c-2f5d36d6e12a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Mazzio's",
      "poi_type": "Restaurants",
      "poi_address": "4705 SE 29th St, Del City, OK 73115, USA",
      "poi_short_description": "Family-friendly chain featuring pizzas, pastas, salads & subs, with a weekday lunch buffet.",
      "poi_long_description": "Family-friendly chain featuring pizzas, pastas, salads & subs, with a weekday lunch buffet.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-3686-70dd-abab-1fdbe3ee5cde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3686-70dd-abab-1fdbe3ee5cde",
        "storage_key": "property/6767906449165631/019d7913-3686-70dd-abab-1fdbe3ee5cde.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mazzios.com/find-a-mazzios/?address%5B0%5D&post%5B0%5D=locations&tax%5Brestaurant_features%5D%5B0%5D&distance=25&units=imperial&per_page=200&lat&lng&form=3",
      "poi_directions_map_url": "https://maps.google.com/?cid=824985068393244351&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mazzio-s",
      "poi_latitude": "35.4355187",
      "poi_longitude": "-97.4320477",
      "poi_miles_from_property": "20.2 mi",
      "poi_walking_minutes": "7 hours 34 mins",
      "poi_biking_minutes": "2 hours 21 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 405-799-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d9f-7780-8fef-fe5be86a69f0",
        "storage_key": "property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYe8HCPo9socRv6aUeozvcgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_60305aa0-c0b6-4521-94e3-7a929fe6e263",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Birdie's by Chef Kevin Lee",
      "poi_type": "Restaurants",
      "poi_address": "2201 NW 150th St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this Korean restaurant serves delicious wagyu steak with ginger sauce, bibimbap, tteokbokki, and tots. They highlight the unique flavors, generous portions, and reasonable prices. They also like the great atmosphere and friendly, attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-37c0-748c-aea0-162eb072afe5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-37c0-748c-aea0-162eb072afe5",
        "storage_key": "property/6767906449165631/019d7913-37c0-748c-aea0-162eb072afe5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.birdiesokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3280481059198549188&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "birdie-s-by-chef-kevin-lee",
      "poi_latitude": "35.6240489",
      "poi_longitude": "-97.5514279",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-849-5180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d9f-7780-8fef-fe5be86a69f0",
        "storage_key": "property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ189_7Q0dsocRxDztgSSchi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "custom_b8660680-72a9-432e-9ec2-f3d4f00de9f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Abel's Méxican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5822 NW 50th St, Warr Acres, OK 73122, USA",
      "poi_short_description": "Basic Tex-Mex dishes, along with traditional Mexican fare, are the draw at this colorful taqueria.",
      "poi_long_description": "People say this Mexican restaurant serves flavorful Tex-Mex food with generous portions and a variety of homemade salsas. They also highlight the friendly staff, comfortable atmosphere, and good value.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-4467-710a-bc43-1b5be1140d91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4467-710a-bc43-1b5be1140d91",
        "storage_key": "property/6767906449165631/019d7913-4467-710a-bc43-1b5be1140d91.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://abelsmexicanrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1938917354506844673&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "abel-s-m-xican-restaurant",
      "poi_latitude": "35.52193159999999",
      "poi_longitude": "-97.6170145",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-491-0911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d9f-7780-8fef-fe5be86a69f0",
        "storage_key": "property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDb2wHDYFsocRAXo4pA9r6Bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_c49b593e-b124-4369-9b51-3da3814345ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Pizzeria Gusto",
      "poi_type": "Restaurants",
      "poi_address": "2415 N Walker Ave, Oklahoma City, OK 73103, USA",
      "poi_short_description": "Hip, brick-lined joint offering gourmet wood-fired pies & small plates, plus cocktails & draft beer.",
      "poi_long_description": "People say this pizza restaurant serves delicious Neapolitan-style pizza with a perfectly charred crust, as well as tasty appetizers and sandwiches. They highlight the consistent quality of the food, the generous portions, and the good value, especially during happy hour. They also like the cozy and inviting atmosphere, and the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-438f-74e9-bf89-9308477b9d40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-438f-74e9-bf89-9308477b9d40",
        "storage_key": "property/6767906449165631/019d7913-438f-74e9-bf89-9308477b9d40.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://pizzeria-gusto.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6944109291632279098&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pizzeria-gusto",
      "poi_latitude": "35.4939906",
      "poi_longitude": "-97.5211666",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 30 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 405-437-4992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d9f-7780-8fef-fe5be86a69f0",
        "storage_key": "property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbV5dvU0XsocROj47-ZtuXmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_d29e2f63-5d74-43e1-bcd0-faf8ba57e3db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Buffalo Wild Wings",
      "poi_type": "Restaurants",
      "poi_address": "4130 Northwest Expy 108 Suite 110, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_long_description": "People say this chicken wings restaurant offers a variety of flavors and sauces.\n\nOther reviews mention the food can be cold and the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-4aec-749c-8233-2e7409097d9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4aec-749c-8233-2e7409097d9f",
        "storage_key": "property/6767906449165631/019d7913-4aec-749c-8233-2e7409097d9f.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.buffalowildwings.com/locations/us/ok/oklahoma-city---northwest-exp-/4130-nw-expressway/sports-bar-321?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAxNjYxMjExMC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2292669191141925583&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "buffalo-wild-wings",
      "poi_latitude": "35.5378609",
      "poi_longitude": "-97.5940869",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-842-9464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d9f-7780-8fef-fe5be86a69f0",
        "storage_key": "property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn2RoIxA4socRzyJ_dXsy0R8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "custom_57e20532-f649-4be0-8ad1-22bdbc02d137",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Picasso Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3009 Paseo, Oklahoma City, OK 73103, USA",
      "poi_short_description": "Artsy hangout & bar featuring live music, a farm-to-table menu with vegan options & Sunday brunch.",
      "poi_long_description": "Diners say this restaurant offers a wide variety of vegan options, including the Impossible sliders, Impossible nachos, and cauliflower dish, alongside popular dishes like the lobster bisque, fried goat cheese, and steak pasta. They also highlight the friendly and attentive service, dog-friendly patio seating, and diverse crowd.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-4fa7-7049-91fb-a5d40d5a034c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4fa7-7049-91fb-a5d40d5a034c",
        "storage_key": "property/6767906449165631/019d7913-4fa7-7049-91fb-a5d40d5a034c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.picassosonpaseo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12312893605763581668&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "picasso-cafe",
      "poi_latitude": "35.4999537",
      "poi_longitude": "-97.5234707",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 405-602-2002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d9f-7780-8fef-fe5be86a69f0",
        "storage_key": "property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBS88aFMXsocR5Ia3eH8v4Ko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ed099f9c-3a0a-498a-8400-bb481363645c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "La Baguette Bistro",
      "poi_type": "Restaurants",
      "poi_address": "7408 N May Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Upmarket French cuisine, brunch & housemade baked goods are on offer at this family-owned eatery.",
      "poi_long_description": "People say this French restaurant offers delicious cakes, pastries, and desserts, including chocolate mousse cake, Napoleon cake, and Italian cream cake. They highlight the rich, flavorful, and moist cakes, and the variety of options for those with a sweet tooth. They also like the authentic French cuisine, such as escargot, foie gras, and French onion soup, and the reasonable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-5908-768b-acbb-a8b8d0ef981a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5908-768b-acbb-a8b8d0ef981a",
        "storage_key": "property/6767906449165631/019d7913-5908-768b-acbb-a8b8d0ef981a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.labaguettebistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15740031153461714322&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "la-baguette-bistro",
      "poi_latitude": "35.5455753",
      "poi_longitude": "-97.5651582",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-840-3047",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d9f-7780-8fef-fe5be86a69f0",
        "storage_key": "property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzwAnH1UasocRkt2ql_DSb9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "french_restaurant"
    },
    {
      "id": "custom_90985c2e-2d7d-42b5-8193-33827b41559c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "2425 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "People say this restaurant serves delicious pizookies, ribeye steak, and mashed potatoes. They also highlight the friendly and attentive staff, and the great dining experience.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-5536-70a6-8709-07b6a1be5312.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5536-70a6-8709-07b6a1be5312",
        "storage_key": "property/6767906449165631/019d7913-5536-70a6-8709-07b6a1be5312.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/ok/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=16813775833426105589&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bj-s-restaurant-brewhouse",
      "poi_latitude": "35.6103047",
      "poi_longitude": "-97.5578727",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-748-6770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d9f-7780-8fef-fe5be86a69f0",
        "storage_key": "property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5L30WccsocR9RRpjAmIVuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_527d0871-65e0-4297-9640-d6970d87fcd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Mahogany Prime Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "3241 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Sophisticated restaurant offering steaks, seafood & creative cocktails in refined surroundings.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, seafood, and sides, including lobster macaroni and cheese and carrot cake. They highlight the generous portions, the attentive and professional staff, and the beautiful ambiance. They also like the accommodating table placement and the thoughtful service that makes guests feel special.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-5440-74ef-a426-0a5b5388d540.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5440-74ef-a426-0a5b5388d540",
        "storage_key": "property/6767906449165631/019d7913-5440-74ef-a426-0a5b5388d540.webp",
        "width": 1024,
        "height": 584
      },
      "poi_business_url": "http://mahoganyprimesteakhouse.com/locations/mahogany-oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6052219944289353941&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mahogany-prime-steakhouse",
      "poi_latitude": "35.6103673",
      "poi_longitude": "-97.5755325",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-748-5959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d9f-7780-8fef-fe5be86a69f0",
        "storage_key": "property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEdl3kYwcsocR1cDmKfnN_VM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_fe966948-33ef-4cd0-b537-5994f4cbca33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "6920 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this grocery store offers a wide selection of unique and organic products, including low-sugar cookies, spices, and frozen meals. They highlight the reasonable prices and the spacious, clean, and well-stocked store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-6212-751d-b232-acb2ac68ca9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6212-751d-b232-acb2ac68ca9b",
        "storage_key": "property/6767906449165631/019d7913-6212-751d-b232-acb2ac68ca9b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ok/oklahoma-city/463/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12492303780289745644&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "trader-joe-s",
      "poi_latitude": "35.5555197",
      "poi_longitude": "-97.6361686",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-357-0298",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0e03-720c-9a53-add4a9290bc3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0e03-720c-9a53-add4a9290bc3",
        "storage_key": "property/6767906449165631/019cfb49-0e03-720c-9a53-add4a9290bc3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv9I_JAAFsocR7JJw4hmUXa0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a7d9a5f5-86bd-4f9d-8e41-b5434e968164",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 N Western Ave, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, organic options, and specialty items, including a bakery with delicious desserts, a salad bar, and a cheese selection. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-616f-72e6-bd7b-0f3eef381ffe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-616f-72e6-bd7b-0f3eef381ffe",
        "storage_key": "property/6767906449165631/019d7913-616f-72e6-bd7b-0f3eef381ffe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/oklahomacity?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=551365353270644661&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "35.5340444",
      "poi_longitude": "-97.5305342",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-879-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0e03-720c-9a53-add4a9290bc3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0e03-720c-9a53-add4a9290bc3",
        "storage_key": "property/6767906449165631/019cfb49-0e03-720c-9a53-add4a9290bc3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkeF-rCYasocRtY8nF97Xpgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_468d437a-e06a-4db1-b5cd-88a3e33842d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "12200 N MacArthur Blvd Ste C, Oklahoma City, OK 73162, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers fresh produce, fruits, and vegetables, as well as a good selection of meat, seafood, and organic and whole foods. They also highlight the friendly and helpful staff, the clean and well-organized store, and the great selection of flowers and bulk items.\n\nOther reviews mention some items can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-625e-738a-aa46-d2f3d8a77f82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-625e-738a-aa46-d2f3d8a77f82",
        "storage_key": "property/6767906449165631/019d7913-625e-738a-aa46-d2f3d8a77f82.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://sprouts.com/store/ok/oklahoma-city/nw-oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=5963094106256639797&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "35.5931906",
      "poi_longitude": "-97.6193742",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-384-7577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0e03-720c-9a53-add4a9290bc3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0e03-720c-9a53-add4a9290bc3",
        "storage_key": "property/6767906449165631/019cfb49-0e03-720c-9a53-add4a9290bc3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ54g9xlADsocRNQen7X4qwVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_23a812ec-b635-4a9c-848d-51ec11eec655",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Penn Square Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "1901 Northwest Expy, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Classic enclosed mall with department stores, services & a food court, plus ample parking.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including clothing, specialty shops, and dining choices. They also highlight the fun and laid-back atmosphere, and the clean and well-maintained facilities.\n\nSome reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-6e8c-733b-9789-75680e5476d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6e8c-733b-9789-75680e5476d6",
        "storage_key": "property/6767906449165631/019d7913-6e8c-733b-9789-75680e5476d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/penn-square-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=2811350003534984838&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "penn-square-mall",
      "poi_latitude": "35.5249271",
      "poi_longitude": "-97.5441961",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-842-4424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0da1-7367-bfbf-a3507ddfd838",
        "storage_key": "property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqd3wbBUasocRhvb-2-7rAyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_d1525069-c728-45e0-b14c-6519e80349ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7800 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Department store offering clothing, toys, and other goods, plus a grocery and a pharmacy.",
      "poi_long_description": "People say this department store offers a wide variety of merchandise and is easy to navigate.\n\nOther reviews mention the service can be unhelpful and the prices can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-6daf-7529-9b2d-5687470a787a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6daf-7529-9b2d-5687470a787a",
        "storage_key": "property/6767906449165631/019d7913-6daf-7529-9b2d-5687470a787a.webp",
        "width": 1000,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/622-oklahoma-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=72616393302217797&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.5623547",
      "poi_longitude": "-97.6540121",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-773-2625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0da1-7367-bfbf-a3507ddfd838",
        "storage_key": "property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ3LN2ooEsocRRRSmlzn8AQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_9165ec04-9f89-4dfa-a116-4dcfa84b2de5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Cigarettes For Less / Vape King Smoke Shop kratom",
      "poi_type": "Shopping & Retail",
      "poi_address": "5027 N Rockwell Ave, Bethany, OK 73008, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this tobacco shop offers a wide variety of products, including mushroom chocolate. They highlight the potent effects of the mushroom chocolate. They also like the cool vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-716e-728f-8661-236ffbfea0c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-716e-728f-8661-236ffbfea0c1",
        "storage_key": "property/6767906449165631/019d7913-716e-728f-8661-236ffbfea0c1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9516114785968980938&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cigarettes-for-less-vape-king-smoke-shop-kratom",
      "poi_latitude": "35.521721",
      "poi_longitude": "-97.6371551",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-789-2447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0da1-7367-bfbf-a3507ddfd838",
        "storage_key": "property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyfJXxBQFsocRygOGs_oHEIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_e2eb0e62-cc93-466d-8f3f-512fa6b99a68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "OKC Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "7624 W Reno Ave Suite 380, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Relaxed outdoor mall featuring more than 70 brand-name designer stores of shoes, clothing and more.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores and good deals, especially during sales. They also highlight the clean and well-maintained facilities, and the friendly and helpful service.\n\nOther reviews mention the food court can have limited options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-73d6-72eb-b859-76f24b7ebe00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-73d6-72eb-b859-76f24b7ebe00",
        "storage_key": "property/6767906449165631/019d7913-73d6-72eb-b859-76f24b7ebe00.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.okcoutlets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1773095145334850603&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "okc-outlets",
      "poi_latitude": "35.4625898",
      "poi_longitude": "-97.6473972",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-787-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0da1-7367-bfbf-a3507ddfd838",
        "storage_key": "property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdWyLw68PsocRK0Sn8qNMmxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_422a2b7c-977f-4a3b-8aff-4c525a23ccd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Red Barn Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "822 SW 134th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Antique home-goods vendors spread over 3 buildings, plus a monthly outdoor event.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-7969-7708-82b5-68d681630155.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7969-7708-82b5-68d681630155",
        "storage_key": "property/6767906449165631/019d7913-7969-7708-82b5-68d681630155.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/redbarnmarketok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12058461099810425171&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "red-barn-market",
      "poi_latitude": "35.3336163",
      "poi_longitude": "-97.5291",
      "poi_miles_from_property": "22.4 mi",
      "poi_walking_minutes": "8 hours 19 mins",
      "poi_biking_minutes": "2 hours 23 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 405-308-9170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0da1-7367-bfbf-a3507ddfd838",
        "storage_key": "property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVd3m-8oTsocRUwkRWHtCWKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_6ff63c18-2081-4273-873c-3329aa5ace39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Council Crossings Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "Oklahoma City, OK 73162, USA",
      "poi_short_description": "Shopping center including Ollie's Bargain Outlet, Goodwill, and an Italian restaurant.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-7a78-7031-85c8-19d5d01bc962.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7a78-7031-85c8-19d5d01bc962",
        "storage_key": "property/6767906449165631/019d7913-7a78-7031-85c8-19d5d01bc962.webp",
        "width": 500,
        "height": 332
      },
      "poi_business_url": "http://jahrealty.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9778614970596235377&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "council-crossings-shopping-center",
      "poi_latitude": "35.5678055",
      "poi_longitude": "-97.6585951",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0da1-7367-bfbf-a3507ddfd838",
        "storage_key": "property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJO_o7aWEEsocRcZi0pYGetIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_344b1008-0917-4b7e-a640-862d7f72a081",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Rockwell Plaza Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "7104 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "Strip mall with a variety of chain retailers, from pet supplies to discount stores, as well as casual eateries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-8627-70c8-8efb-965efcd38c2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8627-70c8-8efb-965efcd38c2d",
        "storage_key": "property/6767906449165631/019d7913-8627-70c8-8efb-965efcd38c2d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://amzn.to/4jYqxdL",
      "poi_directions_map_url": "https://maps.google.com/?cid=15393885365356532130&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rockwell-plaza-shopping-center",
      "poi_latitude": "35.5567861",
      "poi_longitude": "-97.6415228",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0da1-7367-bfbf-a3507ddfd838",
        "storage_key": "property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmQBisu4EsocRohEp8y0RotU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9d426ff4-75ba-4215-b1c2-7229bef74041",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Peppertree Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "6444 Northwest Expy, Oklahoma City, OK 73132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-83c3-7488-a1c2-e588d92fc80b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-83c3-7488-a1c2-e588d92fc80b",
        "storage_key": "property/6767906449165631/019d7913-83c3-7488-a1c2-e588d92fc80b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8208366610279751431&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "peppertree-square",
      "poi_latitude": "35.5527665",
      "poi_longitude": "-97.6297117",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0da1-7367-bfbf-a3507ddfd838",
        "storage_key": "property/6767906449165631/019cfb49-0da1-7367-bfbf-a3507ddfd838.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdw7c2twEsocRB9_mN_H56XE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_791ca7ea-08c7-4c55-96bd-791f83de92d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Scenic View Lake Hefner",
      "poi_type": "Entertainment",
      "poi_address": "9688-9904 W Lakeshore Dr, Oklahoma City, OK 73162, USA",
      "poi_short_description": "Scenic spot that some visitors say is cool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-8189-71ce-94fd-cf73f22331e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8189-71ce-94fd-cf73f22331e6",
        "storage_key": "property/6767906449165631/019d7913-8189-71ce-94fd-cf73f22331e6.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9096596638922898578&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "scenic-view-lake-hefner",
      "poi_latitude": "35.573417",
      "poi_longitude": "-97.6158049",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0dc0-75ea-8aa7-4599b5917ec3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0dc0-75ea-8aa7-4599b5917ec3",
        "storage_key": "property/6767906449165631/019cfb49-0dc0-75ea-8aa7-4599b5917ec3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcaHcT7IEsocRkvwCgHKaPX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_713f770c-df0e-4176-aa27-6920c43efbda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Surrey Hills Golf Club",
      "poi_type": "Entertainment",
      "poi_address": "11340 Surrey Hills Blvd, Yukon, OK 73099, USA",
      "poi_short_description": "Golf course featuring unique holes, a pro shop, and a clubhouse serving food and drinks.",
      "poi_long_description": "People say this golf club offers a challenging layout with some tough holes and some wide-open holes.\n\nOther reviews mention the course conditions can be poor and the greens can be unplayable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-91b6-70aa-9739-5600019239d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-91b6-70aa-9739-5600019239d3",
        "storage_key": "property/6767906449165631/019d7913-91b6-70aa-9739-5600019239d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://surreyhillsgolfclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3709673798824698770&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "surrey-hills-golf-club",
      "poi_latitude": "35.5894606",
      "poi_longitude": "-97.7262696",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-373-2471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0dce-72fb-8a97-47a3ee875847.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0dce-72fb-8a97-47a3ee875847",
        "storage_key": "property/6767906449165631/019cfb49-0dce-72fb-8a97-47a3ee875847.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYUCvjABsocRkiOFU6poezM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_club"
    },
    {
      "id": "custom_1827a9dd-620b-4501-bc59-2a96d46d9dd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Topgolf Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "13313 Pawnee Dr, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun experience with golf and good food. They also highlight the great atmosphere and friendly service.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-9872-7017-9b1c-5a001c0448f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-9872-7017-9b1c-5a001c0448f3",
        "storage_key": "property/6767906449165631/019d7913-9872-7017-9b1c-5a001c0448f3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17880991546737991946&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "topgolf-oklahoma-city",
      "poi_latitude": "35.6027127",
      "poi_longitude": "-97.5351879",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-607-7154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d9f-7780-8fef-fe5be86a69f0",
        "storage_key": "property/6767906449165631/019cfb49-0d9f-7780-8fef-fe5be86a69f0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0r8qRocsocRCqEU_xILJvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_deced417-a16b-4f90-8ee4-47283863251c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Oklahoma City National Memorial & Museum",
      "poi_type": "Entertainment",
      "poi_address": "620 N Harvey Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "A garden, pool & sculptural memorial commemorating victims of the 1995 Murrah Building bombing.",
      "poi_long_description": "Visitors say this memorial and museum offers a moving experience, honoring the lives lost in the 1995 Oklahoma City bombing. They also highlight the peaceful and serene atmosphere, with many finding it a place for quiet reflection and remembrance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-94bb-75c9-94ef-32170ac4af56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-94bb-75c9-94ef-32170ac4af56",
        "storage_key": "property/6767906449165631/019d7913-94bb-75c9-94ef-32170ac4af56.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://memorialmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4635276338053722639&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-national-memorial-museum",
      "poi_latitude": "35.4731496",
      "poi_longitude": "-97.5170593",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "5 hours 0 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 405-235-3313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d93-730a-b85b-adc19b31ea4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d93-730a-b85b-adc19b31ea4a",
        "storage_key": "property/6767906449165631/019cfb49-0d93-730a-b85b-adc19b31ea4a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq81FLi4XsocRDzJ3TUXPU0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e634d076-b3d6-4195-8de7-224be6ead96c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "National Cowboy & Western Heritage Museum",
      "poi_type": "Entertainment",
      "poi_address": "1700 NE 63rd St, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Dioramas, artifacts, art & more documenting & interpreting the history of the American West.",
      "poi_long_description": "People say this heritage museum offers a vast collection of Western art, artifacts, and historical exhibits, including sculptures, paintings, clothing, and personal items from historical figures. They highlight the educational and family-friendly atmosphere, with engaging multi-media displays, outdoor exhibits, and a playground. They also like the friendly and knowledgeable staff, and the informative presentations by docents. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-a0d0-7368-b4d3-c1f3ff50b1b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a0d0-7368-b4d3-c1f3ff50b1b6",
        "storage_key": "property/6767906449165631/019d7913-a0d0-7368-b4d3-c1f3ff50b1b6.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://nationalcowboymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4849781199640138445&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "national-cowboy-western-heritage-museum",
      "poi_latitude": "35.5356997",
      "poi_longitude": "-97.4831286",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 21 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 405-478-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0d93-730a-b85b-adc19b31ea4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0d93-730a-b85b-adc19b31ea4a",
        "storage_key": "property/6767906449165631/019cfb49-0d93-730a-b85b-adc19b31ea4a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-cenbQZsocRzRLrSk7iTUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4b2229f2-e684-47f8-929a-1396ab56914c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Oklahoma Centennial Land Run Monument",
      "poi_type": "Entertainment",
      "poi_address": "Oklahoma Centennial Land Run Monument, Oklahoma City, OK 73129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7677821841414544103&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-centennial-land-run-monument",
      "poi_latitude": "35.4614521",
      "poi_longitude": "-97.5049335",
      "poi_miles_from_property": "14.6 mi",
      "poi_walking_minutes": "5 hours 30 mins",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0dce-72fb-8a97-47a3ee875847.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0dce-72fb-8a97-47a3ee875847",
        "storage_key": "property/6767906449165631/019cfb49-0dce-72fb-8a97-47a3ee875847.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYe2gsd8WsocR59o_MkkajWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f6459541-be36-4bad-9cde-0a962c9a6488",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Thunder Cleaning Services OKC",
      "poi_type": "Entertainment",
      "poi_address": "6425 Winchester Dr, Oklahoma City, OK 73162, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-a595-75ae-82c3-83bdff7003dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a595-75ae-82c3-83bdff7003dd",
        "storage_key": "property/6767906449165631/019d7913-a595-75ae-82c3-83bdff7003dd.webp",
        "width": 1024,
        "height": 684
      },
      "poi_business_url": "http://www.thundercleaningservicesokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13893539518169662383&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "thunder-cleaning-services-okc",
      "poi_latitude": "35.59359260000001",
      "poi_longitude": "-97.6285998",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-972-8473",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0dce-72fb-8a97-47a3ee875847.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0dce-72fb-8a97-47a3ee875847",
        "storage_key": "property/6767906449165631/019cfb49-0dce-72fb-8a97-47a3ee875847.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi_0PxM3znIERr8NapZTEz8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_29a5545c-ca90-4e4c-b84b-3b2f08bc9a16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Myriad Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "301 W Reno Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "A 15-acre facility with formal gardens, a tropical conservatory, a dog park & horticultural classes.",
      "poi_long_description": "People say this botanical garden offers a wide variety of plants, including tropical plants, orchids, and tulips, and features a conservatory, greenhouse, and walking paths. They highlight the beautiful and peaceful atmosphere, perfect for relaxing and taking photos, and the family-friendly amenities, such as a playground, splash pad, and carousel. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-abb3-73e9-bfef-505610792a2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-abb3-73e9-bfef-505610792a2f",
        "storage_key": "property/6767906449165631/019d7913-abb3-73e9-bfef-505610792a2f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.myriadgardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10363530004578021372&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "myriad-botanical-gardens",
      "poi_latitude": "35.46533110000001",
      "poi_longitude": "-97.5179073",
      "poi_miles_from_property": "13.7 mi",
      "poi_walking_minutes": "5 hours 10 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 405-445-7080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0dce-72fb-8a97-47a3ee875847.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0dce-72fb-8a97-47a3ee875847",
        "storage_key": "property/6767906449165631/019cfb49-0dce-72fb-8a97-47a3ee875847.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA05XnykXsocR_K_5faGn0o8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_173a6ed3-858c-410f-a705-58e936b31c16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Scissortail Park",
      "poi_type": "Entertainment",
      "poi_address": "300 SW 7th St, Oklahoma City, OK 73109, USA",
      "poi_short_description": "Lively space including gardens, a lake & playground, also home to a farmers' market & concerts.",
      "poi_long_description": "People say this park offers a variety of activities, including walking trails, a splash pad, a playground, and a ninja course. They highlight the beautiful landscaping, flowers, and views, as well as the fun and family-friendly vibe. They also like the free parking and the availability of food trucks and a farmers market.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019d7913-ae06-75d8-97e4-10de20b9488c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ae06-75d8-97e4-10de20b9488c",
        "storage_key": "property/6767906449165631/019d7913-ae06-75d8-97e4-10de20b9488c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://scissortailpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2532545101640635246&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "scissortail-park",
      "poi_latitude": "35.4596348",
      "poi_longitude": "-97.5176865",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "5 hours 20 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 405-445-6277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-0dc0-75ea-8aa7-4599b5917ec3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-0dc0-75ea-8aa7-4599b5917ec3",
        "storage_key": "property/6767906449165631/019cfb49-0dc0-75ea-8aa7-4599b5917ec3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fS8K30XsocRbhPyGFpoJSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9e5d618b-3151-4fb0-ae8a-acf6acfe4d81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Tokyo Moon OKC",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "tokyo-moon-okc",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_79c2addc-fded-444c-9627-e40170767249",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "Business Women’s Golf Association",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "business-women-s-golf-association",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_83ace3e0-8bc6-4fea-a273-6f47a2b8ed07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "45th Infantry Division Museum",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "45th-infantry-division-museum",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a7f18028-d17f-41e5-82f0-5b9de485e686",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "poi_name": "OKC Zoo",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "okc-zoo",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_e96d276aed2063ad829a5b5d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_060bf9b7b76db7895bc7d9f4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_11e34c4a1150c726e76c26d3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ef7eb12326a1112d10f0fdc4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7c6e78e32f330ffad6fe0eaf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_67bf8b72607b806ae0c470f8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_7ab4a58d-4b00-4c38-8e57-5b823846d9b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "rating": "5.0",
      "name": "Keshawna Davis",
      "text": "I absolutely enjoy living here. I’m so glad I found these apartments. I feel like they’re one of the most affordable ones around . This apartment complex is quiet for the most part and I have really no issues but I will have to say my only complaint is the loud noise from maintenance and landscape crew. Sometimes it’s hard for me to get sleep but then again that’s going to be like that everywhere no matter what apartments you live in. At the end of the day, they are just doing their job so!",
      "date": "2025-08-11",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_755eceab-e623-4359-9f6b-489f52ce8629",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb49-9a0e-7374-8c23-e93c13fb280a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360-degree view of the outdoor swimming pool area with lounge chairs and a building in the background.",
        "public_id": "019cfb49-9a0e-7374-8c23-e93c13fb280a",
        "storage_key": "property/6767906449165631/019cfb49-9a0e-7374-8c23-e93c13fb280a.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Tammaron Village Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5fd24622e9712946d93efa93&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-880b-7246-b0d2-98b07000c8ac",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "tammaron-village-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631"
    },
    {
      "lead_collector_id": "019cf79e-887e-71a9-bd40-819060c314f5",
      "lead_source": "LANDING_PAGE",
      "name": "tammaron-village-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "generator",
      "page_item_url": "oklahoma-city-apartments-with-pool",
      "search_query": "apartments with pool in Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Oklahoma City",
      "h2_subtitle": "Relax and unwind at Tammaron Village Apartments with a shimmering pool. Discover Oklahoma City living at its finest, featuring our resort-style amenities.",
      "page_copy": "Discover Tammaron Village Apartments where stylish living awaits in Oklahoma City. Offering both one- and two-bedroom units, our community boasts a stunning swimming pool perfect for relaxation and leisure. Dive into the refreshing waters or soak up the sun by our expansive poolside. \n\nLocated in the vibrant Roxboro district, our apartments provide easy access to the best of Oklahoma City. Beyond the inviting pool, enjoy community features like a cozy clubhouse and a dedicated dog park. Explore our range of floor plans with spacious closets and modern amenities, including stackable washers and dryers. Your ideal living experience is here, just waiting for you to make it home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, ottoman, and dining area.",
        "public_id": "019cfb48-e3fa-726d-b6db-dbfa92697dff",
        "storage_key": "property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Oklahoma City",
      "seo_description": "Discover Tammaron Village Apartments with a sparkling pool in Oklahoma City. Enjoy one- and two-bedroom options with resort-style amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "generator",
      "page_item_url": "roxboro-ok-pet-friendly-apartments",
      "search_query": "pet-friendly apartments in Roxboro OK",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Roxboro OK",
      "h2_subtitle": "Tammaron Village Apartments in Roxboro offers pet-friendly living with a dedicated dog park. Enjoy welcoming amenities in Oklahoma City.",
      "page_copy": "Welcome to Tammaron Village Apartments, where pet-friendly living in Roxboro, OK, meets premium comfort. Our community is enriched with amenities that cater to both you and your four-legged friend. Take advantage of our dedicated dog park, where your pet can play freely in a safe environment. \n\nIn addition to being a haven for pets, our apartments in Roxboro offer one- and two-bedroom floor plans with features like spacious closets and modern appliances, including stackable washers and dryers. Live near the heart of Oklahoma City while enjoying community amenities such as a shimmering pool and a cozy clubhouse. Choose Tammaron Village Apartments and enjoy a welcoming environment for both you and your beloved pet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, ottoman, and dining area.",
        "public_id": "019cfb48-e3fa-726d-b6db-dbfa92697dff",
        "storage_key": "property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Roxboro OK",
      "seo_description": "Find pet-friendly apartments in Roxboro, OK at Tammaron Village. Enjoy a dog park and welcoming amenities in Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "generator",
      "page_item_url": "oklahoma-city-apartments-with-dishwasher",
      "search_query": "apartments with dishwasher Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Oklahoma City",
      "h2_subtitle": "Discover modern convenience at Tammaron Village Apartments in Oklahoma City, featuring dishwashers in select units. Explore stylish living today.",
      "page_copy": "At Tammaron Village Apartments in Oklahoma City, experience the convenience of having a dishwasher in select units. Our one- and two-bedroom floor plans are designed with your comfort in mind, making cleaning up after meals a breeze.\n\nLocated in the Roxboro neighborhood, our community combines style with practicality. Beyond kitchens with dishwashers, enjoy amenities such as limited access gates, spacious closets, and a shimmering pool. Whether you're unwinding in the cozy clubhouse or making use of the two laundry facilities, Tammaron Village Apartments provide a seamless blend of convenience and style. Discover your next home with us, where modern living meets everyday ease.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, ottoman, and dining area.",
        "public_id": "019cfb48-e3fa-726d-b6db-dbfa92697dff",
        "storage_key": "property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in Oklahoma City",
      "seo_description": "Explore Tammaron Village Apartments with dishwashers in select units, offering stylish living in Oklahoma City. Enjoy modern amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "generator",
      "page_item_url": "luxury-clubhouse-apartments-73162",
      "search_query": "luxury clubhouse apartments 73162",
      "category": "Amenity",
      "h1_title": "Luxury Clubhouse Apartments in 73162",
      "h2_subtitle": "Experience elegance at Tammaron Village Apartments in Oklahoma City's 73162 with our luxury clubhouse. Indulge in stylish living today.",
      "page_copy": "Welcome to Tammaron Village Apartments, where elegance and comfort converge in the heart of Oklahoma City's 73162 area. Our luxury clubhouse stands out as a signature feature, offering residents a chic space to relax, socialize, or engage in community events. It’s perfect for unwinding after a long day or hosting gatherings.\n\nLocated in the vibrant Roxboro area, our one- and two-bedroom apartments offer more than just a luxury clubhouse. Enjoy resort-style amenities such as a shimmering pool and a dedicated dog park. With spacious closets and modern conveniences like stackable washers and dryers, Tammaron Village Apartments presents an ideal blend of style and practicality. Experience the high life with us in the 73162 zip code.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, ottoman, and dining area.",
        "public_id": "019cfb48-e3fa-726d-b6db-dbfa92697dff",
        "storage_key": "property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Clubhouse Apartments in 73162",
      "seo_description": "Discover Tammaron Village Apartments in 73162. Enjoy our luxury clubhouse and stylish living in Oklahoma City with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "generator",
      "page_item_url": "oklahoma-city-apartment-in-unit-washer-dryer",
      "search_query": "in-unit washer dryer apartment Oklahoma City",
      "category": "Amenity",
      "h1_title": "In-Unit Washer Dryer Apartment Oklahoma City",
      "h2_subtitle": "Enjoy the convenience of an in-unit washer dryer at Tammaron Village Apartments, Oklahoma City. Modern living in Roxboro awaits you.",
      "page_copy": "Discover modern living at Tammaron Village Apartments in Oklahoma City, where some units feature the convenience of an in-unit washer dryer. This amenity underscores our commitment to hassle-free living, allowing you to handle laundry with ease in the comfort of your own home.\n\nSituated in the picturesque Roxboro neighborhood, our community offers thoughtfully designed one- and two-bedroom floor plans. Beyond in-unit laundry, enjoy amenities such as a shimmering pool and a dedicated dog park. With spacious closets and limited access gates, Tammaron Village Apartments blend comfort with convenience, making it an exceptional choice for those seeking an elevated lifestyle in Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, ottoman, and dining area.",
        "public_id": "019cfb48-e3fa-726d-b6db-dbfa92697dff",
        "storage_key": "property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Washer Dryer Apartment Oklahoma City",
      "seo_description": "Tammaron Village Apartments in Oklahoma City offers in-unit washer dryers in select units. Enjoy modern amenities in the Roxboro neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "generator",
      "page_item_url": "studio-apartments-roxboro-ok",
      "search_query": "studio apartments roxboro ok",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Roxboro, OK",
      "h2_subtitle": "Explore studio living at Tammaron Village Apartments in Roxboro, OK. Discover comfort and convenience in a vibrant community.",
      "page_copy": "While Tammaron Village Apartments specializes in one- and two-bedroom floor plans, the Roxboro area offers a range of studio living options for those seeking a cozy and efficient home setup. Situated in Oklahoma City, our vibrant community is designed to foster a comfortable lifestyle, supported by a suite of resort-style amenities.\n\nResidents enjoy features such as spacious closets, a well-equipped clubhouse, and a shimmering pool. Tammaron Village is also pet-friendly with a dedicated dog park. If you're searching for an ideal studio apartment option in Roxboro, OK, our community stands out. Enjoy convenient access to local amenities while soaking in the comfort of a stylish home setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, ottoman, and dining area.",
        "public_id": "019cfb48-e3fa-726d-b6db-dbfa92697dff",
        "storage_key": "property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Roxboro, OK",
      "seo_description": "Explore Tammaron Village Apartments in Roxboro, OK, featuring studio-style options with modern conveniences and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-okc",
      "search_query": "1 bedroom apartments okc",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in OKC",
      "h2_subtitle": "Discover charming 1 bedroom apartments at Tammaron Village in OKC. Enjoy modern amenities in a welcoming community setting.",
      "page_copy": "Welcome to Tammaron Village Apartments, offering charming one-bedroom apartments in the heart of Oklahoma City. These thoughtfully designed units provide the perfect blend of comfort and style, complete with spacious closets and a range of modern amenities tailored to fit your lifestyle.\n\nLocated in the desirable Roxboro neighborhood, our community features a shimmering pool, limited access gates, and a dedicated dog park, ensuring a welcoming environment for both relaxation and active living. With easy access to local shops and dining, our one-bedroom apartments provide the ideal home base in OKC, whether you're working or just enjoying life in this vibrant city.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, ottoman, and dining area.",
        "public_id": "019cfb48-e3fa-726d-b6db-dbfa92697dff",
        "storage_key": "property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in OKC",
      "seo_description": "Find your ideal home in OKC with Tammaron Village Apartments' 1 bedroom options, featuring modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-73162",
      "search_query": "2 bedroom apartments 73162",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in 73162",
      "h2_subtitle": "Explore spacious 2 bedroom apartments at Tammaron Village, located in the 73162 zip code. Discover exceptional living in Oklahoma City.",
      "page_copy": "Experience the perfect blend of comfort and style with our spacious two-bedroom apartments at Tammaron Village Apartments, ideally situated in the 73162 zip code of Oklahoma City. Each unit is thoughtfully designed to offer ample living space, coupled with modern conveniences like spacious closets and select units with stackable washers and dryers.\n\nLocated in the vibrant neighborhood of Roxboro, residents can also enjoy resort-style amenities, including a shimmering pool, a cozy clubhouse, and convenient laundry facilities. With limited access gates and a dedicated dog park, our community delivers a peaceful and enjoyable lifestyle, making it a top choice for those seeking exceptional two-bedroom apartments in this area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, ottoman, and dining area.",
        "public_id": "019cfb48-e3fa-726d-b6db-dbfa92697dff",
        "storage_key": "property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in 73162",
      "seo_description": "Discover Tammaron Village's spacious 2 bedroom apartments in the 73162 area, offering modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "generator",
      "page_item_url": "apartments-near-southern-nazarene-university-oklahoma-city",
      "search_query": "apartments near southern nazarene university oklahoma city",
      "category": "School",
      "h1_title": "Apartments Near Southern Nazarene University",
      "h2_subtitle": "Find ideal apartments near Southern Nazarene University at Tammaron Village, offering modern amenities and convenient living in Oklahoma City.",
      "page_copy": "Located just a short drive from Southern Nazarene University, Tammaron Village Apartments in Oklahoma City offers a convenient home base for students and faculty alike. Nestled in the Roxboro neighborhood, our community provides easy access to campus while delivering a peaceful retreat with resort-inspired amenities.\n\nResidents can enjoy a shimmering pool, cozy clubhouse, and spacious one- and two-bedroom floor plans, perfect for both quiet study sessions and relaxing weekends. With two dedicated laundry facilities and limited access gates, Tammaron Village ensures comfort and security. Explore the perfect proximity to Southern Nazarene University and vibrant Oklahoma City living here!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, ottoman, and dining area.",
        "public_id": "019cfb48-e3fa-726d-b6db-dbfa92697dff",
        "storage_key": "property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Southern Nazarene University",
      "seo_description": "Explore nearby Tammaron Village, offering modern living and close proximity to Southern Nazarene University in Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "generator",
      "page_item_url": "apartments-near-integris-health-baptist-medical-center-oklahoma-city",
      "search_query": "apartments near INTEGRIS Health Baptist Medical Center Oklahoma City",
      "category": "Hospital",
      "h1_title": "Apartments Near INTEGRIS Health Baptist Medical",
      "h2_subtitle": "Discover convenient living with apartments near INTEGRIS Health Baptist Medical Center. Tammaron Village offers the ideal blend of comfort and location in Oklahoma City.",
      "page_copy": "Situated just a quick drive away from INTEGRIS Health Baptist Medical Center, Tammaron Village Apartments provides a practical and comfortable living option for healthcare professionals and patients' families in Oklahoma City. Enjoy the convenience of living close to the medical center without compromising on comfort.\n\nOur community in the Roxboro area features a selection of one- and two-bedroom apartments with spacious interiors and modern amenities like a cozy clubhouse and a shimmering pool. Whether you're looking for a peaceful environment after a long shift or a base close to medical care, Tammaron Village ensures a supportive and convenient lifestyle in OKC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, ottoman, and dining area.",
        "public_id": "019cfb48-e3fa-726d-b6db-dbfa92697dff",
        "storage_key": "property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near INTEGRIS Health Baptist Medical",
      "seo_description": "Live close to INTEGRIS Health Baptist Medical Center at Tammaron Village, offering comfortable apartment living in Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "generator",
      "page_item_url": "oklahoma-city-apartments-close-to-mercy-hospital",
      "search_query": "Oklahoma City apartments close to Mercy Hospital",
      "category": "Hospital",
      "h1_title": "OKC Apartments Close to Mercy Hospital",
      "h2_subtitle": "Explore Oklahoma City apartments close to Mercy Hospital at Tammaron Village. Enjoy convenience and comfort in our Roxboro community.",
      "page_copy": "Tammaron Village Apartments offers an ideal location for those seeking proximity to Mercy Hospital while enjoying the charm of Oklahoma City living. Our community is conveniently situated, making it a great choice for medical professionals and patients' families looking for nearby accommodations.\n\nResidents benefit from spacious one- and two-bedroom layouts, enhanced by thoughtful amenities such as a shimmering pool and a welcoming clubhouse. Whether it's the dedicated dog park or the robust local community in Roxboro, Tammaron Village balances both convenience and comfort, providing an exceptional living experience near Mercy Hospital in Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, ottoman, and dining area.",
        "public_id": "019cfb48-e3fa-726d-b6db-dbfa92697dff",
        "storage_key": "property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "OKC Apartments Close to Mercy Hospital",
      "seo_description": "Discover Tammaron Village apartments near Mercy Hospital, offering modern amenities and convenient living in Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "generator",
      "page_item_url": "apartments-near-martin-park-nature-center-okc",
      "search_query": "apartments near martin park nature center okc",
      "category": "Park",
      "h1_title": "Apartments Near Martin Park Nature Center OKC",
      "h2_subtitle": "Discover serene apartments near Martin Park Nature Center at Tammaron Village, blending nature with urban living in Oklahoma City.",
      "page_copy": "Experience the perfect mix of nature and city living at Tammaron Village Apartments, located just a short distance from Martin Park Nature Center in Oklahoma City. Embrace the tranquility and beauty of the outdoors while enjoying the contemporary comforts offered by our community.\n\nOur one- and two-bedroom apartments provide a peaceful escape with amenities like a shimmering pool and spacious closets. Residents of Tammaron Village can relish in the proximity to lush trails and the natural beauty of Martin Park, making it an ideal location for nature enthusiasts looking for convenient living in OKC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, ottoman, and dining area.",
        "public_id": "019cfb48-e3fa-726d-b6db-dbfa92697dff",
        "storage_key": "property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Martin Park Nature Center OKC",
      "seo_description": "Live near Martin Park Nature Center at Tammaron Village, offering a perfect blend of nature and urban apartment living in Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "generator",
      "page_item_url": "rental-homes-by-stars-and-stripes-park-oklahoma-city",
      "search_query": "rental homes by stars and stripes park oklahoma city",
      "category": "Park",
      "h1_title": "Rental Homes by Stars and Stripes Park OKC",
      "h2_subtitle": "Explore rental homes by Stars and Stripes Park in OKC at Tammaron Village. Enjoy vibrant living near Oklahoma City's scenic attractions.",
      "page_copy": "Discover a community that offers both convenience and a connection to nature at Tammaron Village Apartments, located near the picturesque Stars and Stripes Park in Oklahoma City. Ideal for those seeking vibrant living, our rental homes provide easy access to lush green spaces and lakeside views.\n\nTammaron Village features well-appointed one- and two-bedroom homes that combine comfort and style. Residents can indulge in amenities such as a shimmering pool, spacious closets, and a cozy clubhouse while being within reach of the recreational options offered by Stars and Stripes Park. Enjoy the best of Oklahoma City's urban lifestyle amidst natural beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, ottoman, and dining area.",
        "public_id": "019cfb48-e3fa-726d-b6db-dbfa92697dff",
        "storage_key": "property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes by Stars and Stripes Park OKC",
      "seo_description": "Find your new home by Stars and Stripes Park at Tammaron Village, offering comfortable rental living in Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "generator",
      "page_item_url": "living-close-to-bluff-creek-park-73162",
      "search_query": "living close to bluff creek park 73162",
      "category": "Park",
      "h1_title": "Living Close to Bluff Creek Park 73162",
      "h2_subtitle": "Embrace living close to Bluff Creek Park, 73162, at Tammaron Village, where nature meets modern apartment comforts in Oklahoma City.",
      "page_copy": "At Tammaron Village Apartments, experience the tranquility and recreation of living close to Bluff Creek Park in the 73162 area of Oklahoma City. Our community offers easy access to the scenic trails and natural beauty of the park, perfect for outdoor enthusiasts and those seeking an active lifestyle.\n\nOur thoughtfully designed one- and two-bedroom apartments are complemented by amenities like spacious closets and a shimmering pool. Whether you're enjoying a hike in Bluff Creek Park or relaxing at home, Tammaron Village provides a unique blend of nature and urban convenience, making it an ideal choice for anyone looking to live near Oklahoma City's outdoor retreats.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, ottoman, and dining area.",
        "public_id": "019cfb48-e3fa-726d-b6db-dbfa92697dff",
        "storage_key": "property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Bluff Creek Park 73162",
      "seo_description": "Experience life near Bluff Creek Park at Tammaron Village, with modern amenities and nature access in the 73162 area of Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165631",
      "source": "generator",
      "page_item_url": "tammaron-village-apartments-near-dolese-park-oklahoma",
      "search_query": "tammaron village apartments near dolese park oklahoma",
      "category": "Park",
      "h1_title": "Tammaron Village Apartments Near Dolese Park",
      "h2_subtitle": "Explore Tammaron Village Apartments near Dolese Park in Oklahoma City. Enjoy modern living with easy access to recreational activities.",
      "page_copy": "Tammaron Village Apartments offers a prime location for those desiring proximity to Dolese Park in Oklahoma City. Our community is the perfect spot for individuals seeking both urban comfort and outdoor leisure. With Dolese Park just minutes away, you'll have endless opportunities for recreation and relaxation.\n\nOur one- and two-bedroom apartments provide the ideal blend of style and function. Experience amenities like spacious closets and a cozy clubhouse while enjoying the vibrant setting of nearby Dolese Park. Tammaron Village combines the best of apartment living with convenient access to one of Oklahoma City's cherished green spaces.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
      "featured_image_media": {
        "alt_text": "Living room with sofa, ottoman, and dining area.",
        "public_id": "019cfb48-e3fa-726d-b6db-dbfa92697dff",
        "storage_key": "property/6767906449165631/019cfb48-e3fa-726d-b6db-dbfa92697dff.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tammaron Village Apartments Near Dolese Park",
      "seo_description": "Discover Tammaron Village, near Dolese Park in OKC. Enjoy modern apartment living with park access and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5220"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-BELD0JHFT2"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041152116"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/tammaron-village/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M44V4CPF"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165631/019d1bda-1251-773f-9740-a02fdb1abb98.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-617-8978"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64e8c7ad7c6af604be46a717"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjBXUldTRGZpbWZuNTE5bHlFSVpTVEE9PSIsInZhbHVlIjoiTUhxZjcrdkJFMjhZUGZjNnhHYW5OQT09IiwibWFjIjoiODg5ZDk4YjYwZjBmZDNmZTU0MmE5YmIxYzU4ZGMxYWUxMmY4ZjdkMzYwZTExNjFlMzkwY2ViMjMyMjQyNzVjOSJ9"
    }
  ],
  "custom_qb_id": "5220",
  "custom_ga4_id": "G-BELD0JHFT2",
  "custom_repli_id": "10041152116",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/tammaron-village/register/",
  "custom_google_gtm_id": "GTM-M44V4CPF",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165631/019d1bda-1251-773f-9740-a02fdb1abb98.pdf",
  "custom_ppc_tracking_phone_number": "866-617-8978",
  "custom_residentboost_apartment_id": "64e8c7ad7c6af604be46a717",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjBXUldTRGZpbWZuNTE5bHlFSVpTVEE9PSIsInZhbHVlIjoiTUhxZjcrdkJFMjhZUGZjNnhHYW5OQT09IiwibWFjIjoiODg5ZDk4YjYwZjBmZDNmZTU0MmE5YmIxYzU4ZGMxYWUxMmY4ZjdkMzYwZTExNjFlMzkwY2ViMjMyMjQyNzVjOSJ9"
};

export const generatedAt = '2026-08-27T21:36:10.119Z';
